/* Auto-generated: keeps all stores but slightly offsets duplicate lat/lng so markers don't overlap. */
window.verkooppunten = [
  {
    latitude: 51.05195116969476,
    longitude: 3.725377684659833,
    name: "WONDR care Flagship Store Gent",
    address: "Koestraat 2, 9000 Gent",
    website: "https://wondr.care/",
    phone: "0469 22 02 22"
  },
  {
    latitude: 51.218423171748995,
    longitude: 4.410785676468382,
    name: "WONDR care Flagship Store Antwerpen",
    address: "Leysstraat 6, 2000 Antwerpen",
    website: "https://wondr.care/",
    phone: "0469 22 02 22"
  },
  {
    latitude: 50.88024340082435,
    longitude:  4.700230686506589,
    name: "WONDR lab Flagship Store Leuven",
    address: "Mechelsestraat 5, 3000 Leuven",
    website: "https://wondr.care/",
  },
  {
    latitude: 51.00286065955482,
    longitude: 4.586871862567546,
    name: "Fit Rijmenam",
    address: "Lange Dreef 31 2820 Bonheiden",
    website: "https://www.natuurvoedingfit.be/",
    phone: "015 51 10 13"
  },
  {
        latitude: 51.206423585973894,
        longitude: 4.2420135689428085,
        name:"Apotheek Thys-De Cuyper",
        address: "Albert Panisstraat 176 9120 Beveren-Kruibeke-Zwijndrecht",
        website: "https://www.apotheekthys-decuyper.be/",
        phone: "+32 3 750 95 20",
    },
    {
        latitude: 50.834331859031245,
        longitude: 2.9222204818387203,
        name:"APOTHEEK BONTE BV",
        address: "Blauwepoortstraat 1 8902 Zillebeke",
        website: "https://www.facebook.com/apotheekbontezillebeke/",
        phone: "057/20.23.36",
    },
    {
        latitude: 51.18460564535428,
        longitude: 3.0063812686440508,
        name:"Apotheek Hanne Martens",
        address: "Marktstraat 32 - 34 8460 Oudenburg",
        website: "https://www.apotheekhm.be/",
        phone: "059 26 60 02",
    },
  {
    latitude: 51.129083160948881,
    longitude: 4.577850315341245,
    name: "Apotheek Van Look in Lier",
    address: "ABerlarij 10, 2500 Lierr",
    website: "https://apotheekvanlook.be/",
    phone: "034910590"
  },
  {
    latitude: 51.022969539649537,
    longitude: 3.9939747334603,
    name: "Bo & Co Decorations",
    address: "Hoogstraat 62/A, 9290 Berlare",
    website: "http://www.bo-decorations.be/",
    phone: "052430411"
  },
  {
    latitude: 50.938293260707674,
    longitude: 4.025147055823444,
    name: "Aalstpharma",
    address: "Gentse Steenweg 49, 9300 Aalst",
    website: "https://aalstpharma.be/",
    phone: "053214384"
  },
  {
    latitude: 51.162819035102736,
    longitude: 4.142266457670622,
    name: "Apotheek Sint-Niklaas Parklaan",
    address: "Parklaan 1, 9100 Sint-Niklaas",
    website: "https://www.coopapotheken.be/a25/",
    phone: "037774829"
  },
  {
    latitude: 51.02871704953489,
    longitude: 3.799177855823445,
    name: "Apotheek Heusden",
    address: "Heusdendorp 1, 9070 Destelbergen",
    website: "https://www.coopapotheken.be/a39/",
    phone: "092306509"
  },
  {
    latitude: 51.113746800100039,
    longitude: 4.174869498317053,
    name: "Apotheek Van Hoecke bvba",
    address: "Burgem. Achiel Heymanstraat 31/A, 9140 Temse",
    website: "https://apotheekvanhoecke.be/",
    phone: "037711379"
  },
  {
    latitude: 50.93694950432721,
    longitude: 3.9823886,
    name: "Apotheek Boutens",
    address: "Dorpsstraat 135, 9420 Erpe-Mere",
    website: "http://www.apotheekboutens.be/",
    phone: "053801572"
  },
  {
    latitude: 51.194921080685397,
    longitude: 4.479625642329379,
    name: "Apotheek Caroline Jugnon BVBA",
    address: "de Robianostraat 139, 2150 Antwerpen",
    website: "https://apotheekjugnon.be/",
    phone: "033210709"
  },
  {
    latitude: 51.039876105978145,
    longitude: 5.300596955823444,
    name: "Apotheek Boits bvba",
    address: "Koolmijnlaan 133, 3550 Heusden-Zolder",
    website: "http://www.apotheekboits.be/",
    phone: "011572342"
  },
  {
    latitude: 51.007024626028397,
    longitude: 3.884383423293778,
    name: "Apotheek Markt 14 - Wetteren",
    address: "Markt 14, 9230 Wetteren",
    website: "http://www.markt14.be/",
    phone: "093690221"
  },
  {
    latitude: 51.19674495447051,
    longitude: 4.459118673011866,
    name: "Apotheek Smet - Van Assche",
    address: "Drakenhoflaan 60, 2100 Antwerpen",
    website: "http://www.apotheeksmet.be/",
    phone: "033211345"
  },
  {
    latitude: 51.222996565232563,
    longitude: 5.439807473011866,
    name: "Apotheek Boseind - Pelt",
    address: "Boseind 18, 3910 Pelt",
    website: "https://www.apotheekboseind.be/",
    phone: "011662829"
  },
  {
    latitude: 50.812292783757727,
    longitude: 4.942532384658755,
    name: "Apotheek Breugelhof - Tienen",
    address: "Kabbeekvest - Breugelhof, 1, 3300 Tienen",
    website: "http://www.apotheekbreugelhof.be/",
    phone: "016813035"
  },
  {
    latitude: 50.801264280748491,
    longitude: 4.954509571164688,
    name: "Apotheek Peeters Grimde - Tienen",
    address: "Sint-Truidensesteenweg 12, 3300 Tienen",
    website: "https://www.apotheek-peeters-grimde.be/",
    phone: "016811264"
  },
  {
    latitude: 51.203065823535432,
    longitude: 4.769893486505933,
    name: "Apotheek Schyvens - Vorselaar",
    address: "Kerkstraat 18, 2290 Vorselaar",
    website: "https://apotheekschyvens.be/",
    phone: "014511315"
  },
  {
    latitude: 50.936942743280319,
    longitude: 3.982377871164689,
    name: "Apotheek Boutens",
    address: "Dorpsstraat 135, 9420 Erpe-Mere",
    website: "http://www.apotheekboutens.be/",
    phone: "053801572"
  },
  {
    latitude: 51.329792524979645,
    longitude: 4.77794242883531,
    name: "Apotheek Derveaux",
    address: "Kerkdreef 20, 2310 Rijkevorsel",
    website: "http://www.apotheekderveaux.be/",
    phone: "033121220"
  },
  {
        latitude: 43.24081477045825,
        longitude:3.121275527367603,
        name:"Le Monde de Mi",
        address: "3 Rue des Chardons, 11110 Salles-d'Aude, France",
        website: "https://lemondedemi.fr/",
    },
  {
    latitude: 51.229370414651861,
    longitude: 2.919852026083088,
    name: "Apotheek Claeys Ann",
    address: "Kapellestraat 85, 8400 Oostende",
    website: "https://www.apotheekclaeys.be/",
    phone: "059701230"
  },
  {
    latitude: 51.229370414651861,
    longitude: 2.919852026083088,
    name: "Apotheek Claeys Ann",
    address: "Kapellestraat 85, 8400 Oostende",
    website: "https://www.apotheekclaeys.be/",
    phone: "059701230"
  },
  {
    latitude: 51.231794069937969,
    longitude: 2.917641283753872,
    name: "Loqual - Oostende",
    address: "Kapellestraat 2, 8400 Oostende",
    website: "https://www.loqual.be/",
    phone: "037556646"
  },
  {
    latitude: 51.242071120319025,
    longitude: 5.322742826083796,
    name: "Apotheek Heide-Heuvel",
    address: "Heide 123, 3920 Lommel",
    website: "http://www.apotheekheideheuvel.be/",
    phone: "011525493"
  },
  {
    latitude: 51.102584658468416,
    longitude: 3.994413041417242,
    name: "Apotheek Huyghe-Hoebeke - Lokeren",
    address: "Zand 5, 9160 Lokeren",
    website: "http://www.apotheekzandoudebrug.be/",
    phone: "093481208"
  },
  {
    latitude: 51.3364196104732,
    longitude: 4.97081666441788,
    name: "Aa. Pharma Oosthoven",
    address: "Polderstraat 32, 2360 Oosthoven",
    website: "https://aapharma.be/",
    phone: "0414 41 12 02"
  },
  {
    latitude: 51.086348615250557,
    longitude: 3.95831958297918,
    name: "Apotheek De Vriese",
    address: "Heiendestraat 11, 9160 Lokeren",
    website: "https://apotheekdevriese.be/",
    phone: "09 348 55 43"
  },
  {
    latitude: 50.917267924240129,
    longitude: 4.114694664417881,
    name: "Studio Lotta ",
    address: "Nieuwe Kassei 55 1790 Affligem",
    website: "https://www.studiolottas.com/",
    phone: ""
  },
  {
    latitude: 50.811414870391495,
    longitude: 3.159403966764161,
    name: "Apotheek Vandromme",
    address: "Roeselarestraat 14 8560 Wevelgem",
    website: "https://apotheekvandromme.be/nl",
    phone: "056 41 12 47"
  },
  {
    latitude: 51.013117524498014,
    longitude: 3.101132674979513,
    name: "SoFeet&Beauty",
    address: "Turkeyenstraat 23B, 8830 Hooglede",
    website: "https://www.facebook.com/DaelSofie",
    phone: "0472 87 01 84"
  },
  {
    latitude: 51.071695350933126,
    longitude: 3.726598022089401,
    name: "SPAZIO24",
    address: "Wiedauwkaai 24 9000 Gent",
    website: "https://www.spazio24.be/",
    phone: "0496 34 11 77"
  },
  {
    latitude: 51.134263954053189,
    longitude: 3.329269564417881,
    name: "Pazzox",
    address: "Parkstraat 2 8730 Beernem",
    website: "https://www.pazzox.be/nl/",
    phone: ""
  },
  {
    latitude: 51.232244065550482,
    longitude: 2.919005122089405,
    name: "Apotheek Piers",
    address: "Breidelstraat 5 8400 Oostende",
    website: "https://apotheekpiers.be/",
    phone: "059 70 28 25"
  },
  {
    latitude: 51.002990744528745,
    longitude: 3.880210222089405,
    name: "Apotheek Wetteren - COOP - Delphine Demeyer",
    address: "Felix Beernaertsplein 10, 9230 Wetteren",
    website: "https://www.coopapotheken.be/pages/16-wetteren",
    phone: "09 369 17 85"
  },
  {
    latitude: 51.366227746994007,
    longitude: 4.984164514443899,
    name: "Jolie Jeune Beautysalon",
    address: "Tommelhof 11, 2380 Ravels",
    website: "http://www.joliejeunebeautysalon.com/",
    phone: "0497707569"
  },
  {
    latitude: 51.05762637447404,
    longitude: 3.741576255821189,
    name: "Apotheek Gent Dampoort - COOP - Anthony Sanders",
    address: "Antwerpsesteenweg 2, 9000 Gent",
    website: "https://www.coopapotheken.be/pages/6-gent-dampoort",
    phone: "09 228 22 63"
  },
  {
    latitude: 51.07128803481568,
    longitude: 3.706166364417879,
    name: "Apotheek Gent Bloemekenswijk - COOP - Karoline Gillis",
    address: "Francisco Ferrerlaan 186, 9000 Gent",
    website: "https://www.coopapotheken.be/pages/13-gent-bloemekenswijk",
    phone: "09 226 46 82"
  },
  {
    latitude: 50.966776402216716,
    longitude: 3.935676166268216,
    name: "Apotheek Smetlede - COOP - Dorien Favyts",
    address: "Schildekensstraat 85, 9340 Lede",
    website: "https://www.coopapotheken.be/pages/32-smetlede",
    phone: "09 369 56 43"
  },
  {
    latitude: 51.158685679855381,
    longitude: 4.144949498149666,
    name: "Apotheek Sint-Niklaas Knaptandstraat - COOP - Lieve Cornelis",
    address: "Knaptandstraat 110, 9100 Sint-Niklaas",
    website: "https://www.coopapotheken.be/pages/26-sintniklaas-knaptandstraat",
    phone: " 03 776 20 89"
  },
  {
    latitude: 51.097719893531078,
    longitude: 4.13798344417881,
    name: "Apotheek Hamme - COOP - Caroline Van der Veken",
    address: "Nieuwstraat 17, 9220 Hamme",
    website: "https://www.coopapotheken.be/pages/17-hamme",
    phone: "052 47 82 84"
  },
  {
    latitude: 51.050196734932648,
    longitude: 4.631647650412621,
    name: "Body-World",
    address: "Tinstraat 42, 2580 Putte",
    website: "http://www.body-world.be/",
    phone: "015330999"
  },
  {
    latitude: 51.131716758425952,
    longitude: 5.455586710736402,
    name: "Studio Greenhouse.be",
    address: "Markt 39, 3990 Peer",
    website: "https://ilsedebeaute.be/",
    phone: "0474454255"
  },
  {
    latitude: 50.928343780152531,
    longitude: 5.336758253054418,
    name: "VOW Sustainable Care",
    address: "Koning Albertstraat 25 3500 - Hasselt BE, 3500",
    website: "https://vow.care/",
    phone: "0479013928"
  },
  {
    latitude: 51.045911720955964,
    longitude: 3.225983885590654,
    name: "Less is Lottie - Wandelcoach - keynotespeaker - podcasthost",
    address: "Hille 152, 8750 Wingene",
    website: "http://www.lessislottie.be/",
    phone: "0474906702"
  },
  {
    latitude: 50.826749337290636,
    longitude: 3.270516553924057,
    name: "K In Kortrijk",
    address: "Steenpoort 2, 8500 Kortrijk",
    website: "http://www.k-in-kortrijk.be/",
    phone: "056313048"
  },
  {
    latitude: 51.193818216406548,
    longitude: 4.096667493253642,
    name: "Apotheek Sint-Pauwels - COOP - Veerle Herweyers",
    address: "Dries 15, 9170 Sint-Gillis-Waas",
    website: "https://www.coopapotheken.be/pages/29-sintpauwels",
    phone: "03 776 29 48"
  },
  {
    latitude: 51.110637847549739,
    longitude: 3.982907689012601,
    name: "Apotheek Lokeren - COOP",
    address: "Tweebruggenstraat 2A, 9160 Lokeren",
    website: "https://www.coopapotheken.be/pages/20-lokeren",
    phone: "09 274 89 86"
  },
  {
    latitude: 51.028007473538963,
    longitude: 4.099528749074833,
    name: "Apotheek Dendermonde - COOP - Cathy Van den Berghe",
    address: "Brusselsestraat 35, 9200 Dendermonde",
    website: "https://www.coopapotheken.be/pages/15-dendermonde",
    phone: "052 22 54 92"
  },
  {
    latitude: 51.149326307421433,
    longitude: 3.234522806746357,
    name: "Apotheek Oostkamp - COOP - Lonis Van Belleghem",
    address: "Kortrijksestraat 105, 8020 Oostkamp",
    website: "https://www.coopapotheken.be/pages/33-oostkamp",
    phone: "050 15 38 70"
  },
  {
    latitude: 51.055758834798354,
    longitude: 3.572411379760929,
    name: "Apotheek Landegem - COOP - Jan Venneman",
    address: "Vosselarestraat 11/bus 0001, 9850 Deinze",
    website: "https://www.coopapotheken.be/pages/4-landegem",
    phone: "09 274 15 30"
  },
  {
    latitude: 51.060487630915432,
    longitude: 3.721111075086876,
    name: "Apotheek Gent AZ Sint-Lucas - COOP - Seppe Thieleman",
    address: "Tichelrei 19 9000 Gent",
    website: "https://www.coopapotheken.be/pages/23-gent-az-sintlucas",
    phone: "+32 9 262 03 95"
  },
  {
    latitude: 51.226164196055997,
    longitude: 2.914465946261003,
    name: "Apotheek - COOP - Oostende Centrum",
    address: "Alfons Pieterslaan 38 8400 Oostende",
    website: "https://www.coopapotheken.be/pages/34-oostende-centrum",
    phone: "+32 59 70 08 35"
  },
  {
    latitude: 50.98888927924272,
    longitude: 5.366909849074834,
    name: "Drukke mama's",
    address: "Heuvenstraat 39, 3520 Zonhoven",
    website: "https://drukkemamas.be/?srsltid=AfmBOorj3uJMEOeeYOoldYnjOFdq8ArbDi8UfebDpiQyg5teWVsfxHzp",
    phone: ""
  },
  {
    latitude: 51.041651005909443,
    longitude: 4.62951337153251,
    name: "Bodyworld",
    address: "Tinstraat 42, 2580 Putte",
    website: "https://www.body-world.be",
    phone: "015330999"
  },
  {
    latitude: 50.963048852028741,
    longitude: 3.753833571164971,
    name: "Apotheek Bottelare",
    address: "Koning Albert I Plein 19,9820 Bottelare",
    website: "https://bottelare.apotheek.be/",
    phone: "+3293626930"
  },
  {
    latitude: 51.206117187561901,
    longitude: 3.219346626458114,
    name: "Loqual Brugge",
    address: "Brugge Zuidzandstraat 32",
    website: "https://loqual.be/winkels/",
    phone: ""
  },
  {
    latitude: 51.216921517901561,
    longitude: 4.40454048044217,
    name: "Loqual Antwerpen",
    address: "Oudaan 15 \u2013 Korte Gasthuisstraat 36 \u2013 Everdijstraat 30, unit nummer 7, 8 en 16 ",
    website: "https://loqual.be/winkels/",
    phone: ""
  },
  {
    latitude: 51.079133959725013,
    longitude: 3.755643425265883,
    name: "Apotheek Sanifar",
    address: "Lourdesstraat 43, 9041 Gent",
    website: "https://www.sanifar.be/",
    phone: "09 251 03 59"
  },
  {
    latitude: 51.056645742738674,
    longitude: 3.796662680294529,
    name: "Apotheek Du Faux",
    address: "Dendermondesteenweg 443, 9070 Destelbergen",
    website: "https://www.apotheekdufaux.be/",
    phone: "09 228 64 82"
  },
  {
    latitude: 51.013644243461222,
    longitude: 3.760791964913004,
    name: "Apotheek Du Faux",
    address: "Fraterstraat 86, 9820 Merelbeke-Melle",
    website: "https://www.apotheekdufaux.be/",
    phone: "09 277 96 60"
  },
  {
    latitude: 50.910583042302683,
    longitude: 3.989346026186084,
    name: "Apotheek De Fr\u00e9",
    address: "Edestraat 85A 9450 Haaltert",
    website: "https://www.apotheekdefre.be/",
    phone: "053 83 85 46"
  },
  {
    latitude: 50.853477355091449,
    longitude: 2.894070056817724,
    name: "Apotheek De French",
    address: "Frenchlaan 41 8900 Ieper",
    website: "https://www.ieper.be/apotheek-de-french",
    phone: "057 201 755"
  },
  {
    latitude: 50.849558984667489,
    longitude: 2.887097326130205,
    name: "Apotheek Saint-Germain",
    address: "Rijselstraat 43 8900 Ieper",
    website: "https://www.apothekensaint-germain.be/onze-apotheken/apotheek-saint-germain/",
    phone: "057 20 08 50"
  },
  {
    latitude: 51.160045536186175,
    longitude: 4.156840996435593,
    name: "Interieur De Mey bvba",
    address: "Brugsken 88, 9100 Sint-Niklaas",
    website: "https://www.interieurdemey.be/",
    phone: "03 776 10 53"
  },
  {
    latitude: 50.899213565692499,
    longitude: 4.060782804703794,
    name: "Apotheek Welle",
    address: "Steenweg 203, 9473 Welle",
    website: "https://apotheekwelle.be/",
    phone: "053 66 79 07"
  },
  {
    latitude: 50.832685795754657,
    longitude: 5.572128895183886,
    name: "Boudoir Lash Boutique",
    address: "3770 Herderen (Riemst) Maastrichterstraat 1/B6",
    website: "",
    phone: "+32493601417"
  },
  {
    latitude: 50.924413331799769,
    longitude: 3.254182171163435,
    name: "Pharma De Cock",
    address: "Bruggestraat 78, 8770 Ingelmunster",
    website: "https://rosa.be/nl/hp/stefanie-vanrobaeys-1/",
    phone: "+3251439247"
  },
  {
    latitude: 50.922178343371257,
    longitude: 3.25536575581717,
    name: "Apotheek Seurinck",
    address: "Schoolstraat 33 8770 Ingelmunster",
    website: "https://www.apotheekseurinck.be/nl",
    phone: "+32 51 33 53 93"
  },
  {
    latitude: 50.818498893488552,
    longitude: 5.180269343248581,
    name: "Apotheek Lauweryns - Sint-Truiden",
    address: "Prins Albertlaan 33, 3800 Sint-Truiden",
    website: "https://lauweryns.apotheek.be/",
    phone: "011682627"
  },
  {
    latitude: 51.065734003970405,
    longitude: 4.02974731534626,
    name: "Apotheek Van Hecke",
    address: "Kouterstraat 90 9240 Zele",
    website: "https://apotheekvanhecke.be/",
    phone: "052 44 44 36"
  },
  {
    latitude: 51.032653967207679,
    longitude: 3.548073897236796,
    name: "Apotheek Vervaeke - Deinze",
    address: "Cyriel Buyssestraat 18, 9850 Deinze",
    website: "https://apotheekvervaeke.be/",
    phone: "093715112"
  },
  {
    latitude: 50.930411201077987,
    longitude: 5.348203257673129,
    name: "Apotheek Theunis",
    address: "Maastrichtersteenweg 49 3500 Hasselt",
    website: "https://www.apotheektheunis.be/",
    phone: "011 22 27 25"
  },
  {
    latitude: 52.037219297378591,
    longitude: 4.198107042326868,
    name: "Schoonheidssalon Jorike",
    address: "Haagweg 37b 2681 PB Monster",
    website: "https://www.schoonheidssalonjorike.nl/",
    phone: "06 1250 6525"
  },
  {
    latitude: 51.074008551938952,
    longitude: 3.730704762400411,
    name: "Apotheek Muide",
    address: "Meulesteedsesteenweg 7, 9000 Gent",
    website: "https://apotheekmuide.apotheek.be/",
    phone: "09 251 05 39"
  },
  {
    latitude: 51.008111663376063,
    longitude: 3.478041186509695,
    name: "Apotheek De Ruyck",
    address: "Aarseleweg 2 - 9800 Vinkt",
    website: "https://www.deruyckpharma.be/",
    phone: "09 386 50 30"
  },
  {
    latitude: 50.824404161061381,
    longitude: 3.2296749,
    name: "Zonnestudio Teint Soleil",
    address: "Meensesteenweg 282, 8501 Kortrijk",
    website: "https://www.zonnestudio-teintsoleil.be/",
    phone: "0477 72 85 11"
  },
  {
    latitude: 51.345069791844942,
    longitude: 3.287802268418975,
    name: "Apotheek Pacoo - Knokke",
    address: "Lippenslaan 113, 8300 Knokke-Heist",
    website: "https://www.apotheekopzak.be/apotheek-pacoo",
    phone: "050601440"
  },
  {
    latitude: 51.210277717782233,
    longitude: 3.247348483752647,
    name: "AApotheek Trui Strybol - Brugge (Sint-Kruis)",
    address: "Maalse Steenweg 109, 8310 Brugge",
    website: "https://apotheekstrybol.be/",
    phone: "050353955"
  },
  {
    latitude: 50.970681545456635,
    longitude: 5.501800168651226,
    name: "Zorgpunt Apotheek Paredis Genk nv",
    address: "Bochtlaan 58, 3600 Genk",
    website: "http://www.apotheekparedis.be/",
    phone: "089622650"
  },
  {
    latitude: 51.146909320434006,
    longitude: 2.712647767598832,
    name: "Apotheek NB Pharma",
    address: "Albert I laan 255, 8620 Nieuwpoort",
    website: "https://www.nbpharma.be/",
    phone: "058 23 41 22"
  },
  {
    latitude: 51.210277717782233,
    longitude: 3.247305568411402,
    name: "Strybol Trui - Brugge",
    address: "Maalse Steenweg 109, 8310 Brugge",
    website: "https://apotheekstrybol.be/",
    phone: "050353955"
  },
  {
    latitude: 51.100030643432817,
    longitude: 3.76351745225197,
    name: "Oostakkerdorp Pharma",
    address: "Oostakkerdorp 26, 9041 Gent",
    website: "https://www.odrppharma.be/",
    phone: "09 251 01 21"
  },
  {
    latitude: 50.963145316630914,
    longitude: 3.913945368397601,
    name: "Danini Bloem Deco Trendy Zoet - Lede",
    address: "Molenhoek 149, 9340 Lede",
    website: "https://www.daninibloemen.be/",
    phone: "093667591"
  },
  {
    latitude: 51.072079572167169,
    longitude: 5.753987956756813,
    name: "Apotheek Decoster - Dilsen-Stokkem",
    address: "Rijksweg 930, 3650 Dilsen-Stokkem",
    website: "https://www.apotheekdecoster.be/",
    phone: "089566406"
  },
  {
    latitude: 49.699941121897481,
    longitude: 5.498878909827217,
    name: "Am\u00e9thyst'\u00d4m",
    address: "Rue du Pont 57, 6730 Tintigny",
    website: "https://www.amethystom.be/",
    phone: ""
  },
  {
    latitude: 51.252800217504593,
    longitude: 4.883095781907874,
    name: "FEATME! - Tielen",
    address: "Gierlebaan 116, 2460 Kasterlee",
    website: "https://featme.be/",
    phone: "0456319173"
  },
  {
    latitude: 50.813105007636061,
    longitude: 5.191291117194887,
    name: "Apotheek Noben",
    address: "Tongersesteenweg 26, 3800 Sint-Truiden",
    website: "https://www.apotheekopzak.be/apotheek-noben",
    phone: "011 68 08 91"
  },
  {
    latitude: 50.811297413098487,
    longitude: 3.181044254895068,
    name: "Apotheek Vandromme - Wevelgem",
    address: "Roeselarestraat 14, 8560 Wevelgem",
    website: "http://www.apotheekvandromme.be/",
    phone: "056411247"
  },
  {
    latitude: 51.039043188174993,
    longitude: 3.547521296427195,
    name: "Apotheek Vidafar",
    address: "Biebuyckstraat 18 Deinze",
    website: "https://www.apotheekvidafar.be/",
    phone: "09 371 76 33"
  },
  {
    latitude: 51.053788920931893,
    longitude: 3.725504379760929,
    name: "Het belfort - Gent",
    address: "Sint-Baafsplein , 9000 Gent",
    website: "https://stad.gent/nl/openingsuren-adressen/belfort",
    phone: "09 266 70 70"
  },
  {
    latitude: 51.268724135895368,
    longitude: 4.86707776441788,
    name: "Gierle Pharma",
    address: "Beersebaan 5, 2275 Lille",
    website: "https://gierlepharma.be/",
    phone: "014 55 75 48"
  },
  {
    latitude: 51.025407180042485,
    longitude: 4.001923997236352,
    name: "Apotheek Spriet - Berlare",
    address: "Dorp 23, 9290 Berlare",
    website: "https://apotheekspriet.be/",
    phone: "052423566"
  },
  {
    latitude: 50.884767145246684,
    longitude: 3.258771722089406,
    name: "Salon Lady E ",
    address: "Harelbeeksestraat 23, 8860 Lendelede",
    website: "https://salonelsy.be/",
    phone: "0494 17 85 20"
  },
  {
    latitude: 51.054554218720199,
    longitude: 3.748994626073318,
    name: "Apotheek Proxiphar BVBA - St-Amandsberg",
    address: "Doornakkerstraat 42, 9040 Gent",
    website: "https://proxiphar.be/",
    phone: "092282243"
  },
  {
    latitude: 50.922753002302073,
    longitude: 3.445692069434512,
    name: "Apotheek Goessaert",
    address: "Staatsbaan 119, 9870 Zulte",
    website: "https://apotheekgoessaert.com/",
    phone: "09 388 86 61"
  },
  {
    latitude: 50.892979018258508,
    longitude: 2.860623012570245,
    name: "Apotheek Sticker - Boezinge",
    address: "Diksmuidseweg 373, 8904 Ieper",
    website: "https://sticker.apotheek.be",
    phone: "057422045"
  },
  {
    latitude: 51.061841558032441,
    longitude: 3.808401154100614,
    name: "Studio knap",
    address: "Kouterstraat 189, 9070 Destelbergen",
    website: "https://www.studioknap.be/",
    phone: "0476 81 36 35"
  },
  {
    latitude: 51.081231392735027,
    longitude: 3.705300296430132,
    name: "Corum Wondelgem",
    address: "Roodborstjesstraat 163A, 9032 Gent",
    website: "https://corumpharma.be/",
    phone: "09 253 11 08"
  },
  {
    latitude: 51.068983867166182,
    longitude: 3.684515615343596,
    name: "Apotheek Corum Mariakerke Zorgpunt",
    address: "Brugsesteenweg 343, 9030 Gent",
    website: "https://corumpharma.be/",
    phone: "09 226 22 49"
  },
  {
    latitude: 51.096247574813553,
    longitude: 4.141659142328202,
    name: "Apotheek HC Pharma",
    address: "Kapellestraat 55, 9220 Hamme",
    website: "https://www.hcpharma.be/nl",
    phone: "052 47 78 86"
  },
  {
    latitude: 51.530358127857731,
    longitude: 5.991649998148708,
    name: "Salon Pure Cindy",
    address: "Kamperfoelie 45, 5803 HL Venray, Nederland",
    website: "https://www.pure-cindy.nl/",
    phone: "0611057983"
  },
  {
    latitude: 50.855142069570505,
    longitude: 2.7358404,
    name: "Apotheek Het Perron",
    address: "Ieperstraat 154, 8970 Poperinge",
    website: "https://www.apotheekhetperron.be/",
    phone: "057 33 31 53"
  },
  {
    latitude: 51.094371210881754,
    longitude: 5.791392997493907,
    name: "Apotheek Markt Maaseik",
    address: "Markt 23, 3680 Maaseik",
    website: "http://www.apotheekmarktmaaseik.be/",
    phone: "089563206"
  },
  {
    latitude: 51.311980308514904,
    longitude: 3.128915513493622,
    name: "De Mind Academie",
    address: "De Smet de Naeyerlaan 141, 8370 Blankenberge",
    website: "https://www.blankenberge.be/academie",
    phone: "050 63 66 90"
  },
  {
    latitude: 50.857008780768489,
    longitude: 2.872629657670918,
    name: "Apotheek Kestelyn",
    address: "Haiglaan 166 8900, Ieper",
    website: "https://www.apotheekkestelyn.be/nl/",
    phone: "+32 57 21 21 22"
  },
  {
    latitude: 51.178264014541071,
    longitude: 4.835884942329082,
    name: "Apotheek De Vooght",
    address: "Hofkwartier 6, 2200 Herentals",
    website: "https://apotheekdevooght.be/",
    phone: "014 21 23 08"
  },
  {
    latitude: 50.949438081069189,
    longitude: 4.580426413493623,
    name: "Relst Pharma",
    address: "Haachtsesteenweg 512, 1910 Kampenhout",
    website: "https://www.relstpharma.be/",
    phone: "016 65 67 06"
  },
  {
    latitude: 51.1024420937404,
    longitude: 5.518268483185169,
    name: "Apotheek Schoofs",
    address: "Weg op Bree 1, 3670 Oudsbergen",
    website: "https://apotheekschoofs.be/nl",
    phone: "011 79 29 41"
  },
  {
    latitude: 51.117574290911755,
    longitude: 5.261216330683675,
    name: "Apotheek Alaerts",
    address: "Maarschalk Fochstraat 36, 3970 Leopoldsburg",
    website: "https://www.leopoldsburgonderneemt.be/bedrijven/detail/4/apotheek-alaerts",
    phone: "011 34 55 89"
  },
  {
    latitude: 51.057013435799576,
    longitude: 4.015516728835459,
    name: "Apotheek Torenhof",
    address: "Gentsesteenweg 207, 9240 Zele",
    website: "https://apotheekgroepzele.be/",
    phone: "052 44 40 45"
  },
  {
    latitude: 51.078945444243423,
    longitude: 4.0427846,
    name: "Apotheek Durmen",
    address: "Huis Ten Halve 32, 9240 Zele",
    website: "https://apotheekgroepzele.be/",
    phone: "052 44 71 71"
  },
  {
    latitude: 51.068851386007729,
    longitude: 4.03782647116454,
    name: "Apotheek De Neve",
    address: "Markt 55, 9240 Zele",
    website: "https://apotheekgroepzele.be/",
    phone: "052 44 40 55"
  },
  {
    latitude: 50.911615614360635,
    longitude: 5.420545839512233,
    name: "Apotheek Piet Souren",
    address: "Marktplein 17, 3590 Diepenbeek",
    website: "https://www.apotheeksouren.be/",
    phone: "011 33 26 42"
  },
  {
    latitude: 50.795492977153145,
    longitude: 5.618804468638497,
    name: "Studio Sparx",
    address: "Vis\u00e9steenweg 190A, 3770  Riemst",
    website: "info@studiosparx.be",
    phone: "0474 45 95 85"
  },
  {
    latitude: 51.033529559574163,
    longitude: 4.473703796617019,
    name: "Apotheek De Bruycker Maryke",
    address: "Nieuwe Beggaardenstraat 37, 2800 Mechelen",
    website: "https://apotheek-de-bruycker.be/nl",
    phone: "015 26 15 51"
  },
  {
    latitude: 50.836779999999997,
    longitude: 4.3587,
    name: "Juttu Brussel",
    address: "Avenue de la Toison d'Or 26-28, 1050 Bruxelles",
    website: "https://www.juttu.be/nl.html",
    phone: "02/771.95.34"
  },
  {
    latitude: 50.876549628906631,
    longitude: 3.733385015344866,
    name: "Apotheek Nicky Bertrand",
    address: "Zuidlaan 66, 9630 Zwalm",
    website: "https://www.apotheekbertrand.be/",
    phone: "055 49 98 62"
  },
  {
    latitude: 50.750541370329259,
    longitude: 3.363383430685531,
    name: "Schoonheidsinstituut Adelinde",
    address: "Dalestraat 77a, 8554 Zwevegem",
    website: "https://schoonheidsinstituut-adelinde.salonized.com/",
    phone: "0473 50 11 36"
  },
  {
    latitude: 51.341222353734764,
    longitude: 3.2924534,
    name: "Apotheek Debruyne Ellen",
    address: "De Klerckstraat 3, 8300 Knokke-Heist",
    website: "https://apotheekknokke.be",
    phone: "050 60 46 42"
  },
  {
    latitude: 50.939421679635188,
    longitude: 3.121792453965402,
    name: "Apotheek Mieke Bouttelisier",
    address: "Meensesteenweg 105, 8800 Roeselare",
    website: "https://miekesapotheek.be/",
    phone: "051 22 60 98"
  },
  {
    latitude: 51.048628997082851,
    longitude: 3.728414477241072,
    name: "GANDA Apotheek De Krook",
    address: "Lammerstraat 37, 9000 Gent",
    website: "https://www.apothekenganda.be/",
    phone: "09 225 20 39"
  },
  {
    latitude: 51.057656071915041,
    longitude: 3.731001930689732,
    name: "Apotheek Steendam",
    address: "Steendam 59, 9000 Gent",
    website: "",
    phone: "09 357 25 69"
  },
  {
    latitude: 50.864180802791019,
    longitude: 4.695873373017958,
    name: "Apotheek Kerre",
    address: "Naamsesteenweg 160, 3001 Leuven",
    website: "https://www.apotheekkerre.be/",
    phone: "016 22 51 75"
  },
  {
    latitude: 51.17792442712458,
    longitude: 4.849345634399183,
    name: "Optiphar Apotheek Geel",
    address: "Dr.-Van de Perrestraat 140, 2440 Geel",
    website: "https://optiphar.com/nl-be/",
    phone: "014 58 37 07"
  },
  {
    latitude: 50.932830323897079,
    longitude: 4.536998303708571,
    name: "Apotheek Kinget Berg Zorgpunt",
    address: "Bergstraat 1, 1910 Kampenhout",
    website: "https://www.apotheek-kinget.be/",
    phone: "016 65 60 98"
  },
  {
    latitude: 51.177776051279025,
    longitude: 4.849097695357169,
    name: "Optiphar Plus Herentals",
    address: "Augustijnenlaan 91, 2200 Herentals",
    website: "https://optipharplus.com/",
    phone: "014 42 32 74"
  },
  {
    latitude: 50.939210555050316,
    longitude: 4.551143611636736,
    name: "Apotheek Kinget Kampenhout Zorgpunt",
    address: "Haachtsesteenweg 293, 1910 Kampenhout",
    website: "https://www.apotheek-kinget.be/",
    phone: "016 65 50 25"
  },
  {
    latitude: 50.869211564732801,
    longitude: 4.697136934399182,
    name: "Apotheek Kinget Leuven Zorgpunt",
    address: "Tervuursevest 17, 3001 Leuven",
    website: "https://www.apotheek-kinget.be/",
    phone: "016 89 45 98"
  },
  {
    latitude: 50.979823787238473,
    longitude: 5.061601308861248,
    name: "Apotheek Hasseltsepoort",
    address: "Hasseltsestraat 71, 3290 Diest",
    website: "https://www.apotheekhasseltsepoort.be/",
    phone: "013 31 22 28"
  },
  {
    latitude: 51.071217179583307,
    longitude: 5.091143859706859,
    name: "Apotheek Binnenhof",
    address: "Binnenhof 14, 3980 Tessenderlo",
    website: "https://www.tessenderlo.be/bedrijven/detail/18/apotheek-binnenhof-nadine-jonkers",
    phone: "013 66 11 17"
  },
  {
    latitude: 51.026000819056257,
    longitude: 3.04151626617346,
    name: "Apotheek Mahieu",
    address: "Stationsplein 5, 8610 Kortemark",
    website: "http://www.mahieuapotheek.be/kortemark",
    phone: "051 721 800"
  },
  {
    latitude: 50.928109488637332,
    longitude: 3.991183709384494,
    name: "Beauty Fly",
    address: "Huytstraat 7, 9320 Nieuwerkerken",
    website: "beautyfly.be",
    phone: "0494 45 32 29"
  },
  {
    latitude: 50.801777170350711,
    longitude: 3.109125482357415,
    name: "Apotheek Debaeke",
    address: "Guido Gezellelaan 60, 8930 Menen",
    website: "https://www.apotheekopzak.be/apotheek-debaeke",
    phone: "056 51 21 84"
  },
  {
    latitude: 51.162749758463391,
    longitude: 4.675007321079578,
    name: "Apotheek Heylen",
    address: "Bouwelsesteenweg 7, 2560 Nijlen",
    website: "https://apotheekheylen.be/",
    phone: "03 481 81 63"
  },
  {
    latitude: 51.095396721540268,
    longitude: 3.715942568864112,
    name: "Apotheek Delphine Van Peteghem",
    address: "Evergemsesteenweg 69, 9032 Gent",
    website: "https://www.apotheekvanpeteghem.be/",
    phone: "09 253 95 96"
  },
{
    latitude: 50.93890102234499,
    longitude: 5.340541497376291,
    name: "Apotheek Mees Hasselt",
    address: "Kempische Steenweg 134, 3500 Hasselt",
    website: "https://apotheekmees.be/",
    phone: "011 96 17 62"
  },
  {
    latitude: 51.126971181632577,
    longitude: 4.495112248168295,
    name: "Violet by Hanne",
    address: "Koning Albertstraat 25, 2547 Lint",
    website: "https://www.violetbyhanne.be/workshops",
    phone: "0497 31 87 05"
  },
  {
    latitude: 50.974690884545751,
    longitude: 5.057749749514602,
    name: "Ontdek de natuur",
    address: "Ketelstraat 19, 3290 Diest",
    website: "https://www.ontdekdenatuur.be/",
    phone: "013 32 59 46"
  },
  {
    latitude: 51.069591304332533,
    longitude: 4.395865712828559,
    name: "GittiZen",
    address: "Grote Bergen 40, 2830 Willebroek",
    website: "https://www.gittizen.com/",
    phone: "0486 80 22 88"
  },
  {
    latitude: 51.123397270075301,
    longitude: 3.5699386979357,
    name: "Apotheek De Melkerij",
    address: "Motje 36/002, 9930 Lievegem",
    website: "https://apotheekdemelkerij.be/",
    phone: "09 377 20 15"
  },
  {
    latitude: 50.978968643827983,
    longitude: 3.015070608458929,
    name: "Apotheek Sana",
    address: "Sint Jansstraat 4, 8840 Staden",
    website: "https://apotheeksana.be/",
    phone: "051 70 10 35"
  },
  {
    latitude: 51.149300498079931,
    longitude: 5.113535159402878,
    name: "Apotheek De Vis",
    address: "Staatsbaan 128/D, 3945 Ham",
    website: "https://www.apotheek24u.be/",
    phone: "013 66 53 14"
  },
  {
    latitude: 50.915875155542501,
    longitude: 4.195983272812229,
    name: "Zorgboetiek Asse",
    address: "Kalkoven 18, 1730 Asse",
    website: "https://www.zorgboetiek.be/mvc/winkel.jsp?id=2",
    phone: "02 452 78 74"
  },
  {
    latitude: 51.057905093141571,
    longitude: 3.278504179757411,
    name: "Apotheek De Voldere",
    address: "Markt 3, 8750 Wingene",
    website: "https://www.apotheekdevoldere.be/",
    phone: "051 65 51 35"
  },
  {
    latitude: 50.951516859474907,
    longitude: 3.124698984101103,
    name: "Zorgboetiek Roeselare",
    address: "Hendrik Consciencestraat 15, 8800 Roeselare",
    website: "https://www.zorgboetiek.be/mvc/winkel.jsp?id=4",
    phone: "050 89 15 34"
  },
  {
    latitude: 50.936593230442796,
    longitude: 5.330578051251466,
    name: "Zorgboetiek Hasselt",
    address: "Kon. Astridlaan 34/1, 3500 Hasselt",
    website: "https://www.zorgboetiek.be/mvc/winkel.jsp?id=3",
    phone: "011 29 10 06"
  },
  {
    latitude: 51.035642773259156,
    longitude: 4.105673417712128,
    name: "Vesna",
    address: "Zuidlaan 4, 9200 Dendermonde",
    website: "https://www.vesna9200.be/",
    phone: "0486 28 01 32"
  },
  {
    latitude: 51.321520769268211,
    longitude: 4.428559920774672,
    name: "Zorgboetiek Kapellen",
    address: "Dorpsstraat 72, 2950 Kapellen",
    website: "https://www.zorgboetiek.be/mvc/winkel.jsp?id=5",
    phone: "03 206 35 50"
  },
  {
    latitude: 50.932830356806797,
    longitude: 4.035051511800138,
    name: "Zorgboetiek Aalst",
    address: "Geraardsbergsestraat 234, 9300 Aalst",
    website: "https://www.zorgboetiek.be/mvc/winkel.jsp?id=1",
    phone: "053 71 00 93"
  },
  {
    latitude: 51.219650808491238,
    longitude: 4.330121914404413,
    name: "Z+ Pharma",
    address: "Statiestraat 131, 2070 Zwijndrecht",
    website: "https://z-pharma.be/",
    phone: "03 252 80 01"
  },
  {
    latitude: 52.15624027143587,
    longitude: 5.388380602895699,
    name: "Beauty Lounge Amersfoort",
    address: "Koestraat 16 A, 3811 HK Amersfoort, Nederland",
    website: "https://www.beautyloungeamersfoort.nl/",
    phone: "+31 33 258 5668"
  },
  {
    latitude: 50.857056878987635,
    longitude: 5.314228623323475,
    name: "Mijn Mineraal",
    address: "Russeltstraat 92, 3830 Wellen",
    website: "https://mijnmineraal.com/",
    phone: ""
  },
  {
    latitude: 51.063639215809225,
    longitude: 3.69855407966156,
    name: "Apotheek Buyse",
    address: "Bevrijdingslaan 154, 9000 Gent",
    website: "https://www.desocialekaart.be/fiches/566836/algemeen",
    phone: "092263291"
  },
  {
    latitude: 51.062262055916378,
    longitude: 3.747829864736997,
    name: "Apotheek Daemers",
    address: "Antwerpsesteenweg 229, 9040 Gent",
    website: "https://apotheekdaemers.be/",
    phone: "092283902"
  },
  {
    latitude: 50.906508583004701,
    longitude: 4.714416713670363,
    name: "Ergosun Leuven",
    address: "Tiensesteenweg 224, 3001 Leuven",
    website: "https://ergosun.be/",
    phone: "016 22 55 01"
  },
  {
    latitude: 50.815161513056722,
    longitude: 5.183833120242588,
    name: "Kreatos Sint-Truiden 1",
    address: "Stapelstraat 9, 3800 Sint-Truiden",
    website: "https://www.kreatos.be/nl/salons/sinttruiden-centrum",
    phone: "011486838"
  },
  {
    latitude: 51.094871439429511,
    longitude: 3.069573867904297,
    name: "Apotheek Cordenier",
    address: "Consciencestraat 47, 8820 Torhout",
    website: "https://cordeniertorhout.apotheek.be/",
    phone: "050 21 14 42"
  },
  {
    latitude: 51.056489657597247,
    longitude: 3.723053339567504,
    name: "Loqual Gent",
    address: "Langemunt 21, 9000 Gent",
    website: "https://loqual.be/",
    phone: ""
  },
  {
    latitude: 51.155234131999435,
    longitude: 4.153274593201595,
    name: "Loqual Waasland Shopping",
    address: "Kapelstraat 100, 9100 Sint-Niklaas",
    website: "https://loqual.be/",
    phone: ""
  },
  {
    latitude: 51.104921863794708,
    longitude: 4.00268327791255,
    name: "Apotheek Oude Brug",
    address: "Oude-Bruglaan 74, 9160 Lokeren",
    website: "https://www.apotheekzandoudebrug.be/",
    phone: "09 391 52 30"
  },
  {
    latitude: 50.907927357573818,
    longitude: 5.35693093742737,
    name: "Kreatos Rapertingen",
    address: "Luikersteenweg 302, 3500 Hasselt",
    website: "https://www.kreatos.be/nl/salons/hasselt-rapertingen",
    phone: "011 28 53 00"
  },
  {
    latitude: 51.320670634359637,
    longitude: 5.08750817791255,
    name: "Marktapotheek Arendonk",
    address: "Vrijheid 42, 2370 Arendonk",
    website: "https://apo2370.be/",
    phone: "014 67 72 83"
  },
  {
    latitude: 51.260104665972548,
    longitude: 4.420310607530822,
    name: "Apotheek Noorderlaan",
    address: "Noorderlaan 104, 2030 Antwerpen",
    website: "https://aponoord.be/",
    phone: "03 541 18 92"
  },
  {
    latitude: 51.178092515686444, 
    longitude: 5.392027485113915,
    name: "Apotheek de Zorghoek",
    address: "Groenstraat 16, 3940 Hechtel-Eksel",
    website: "https://www.dezorghoek.be/",
    phone: "011 73 62 64"
  },
  {
    latitude: 50.89147898539882,
    longitude: 5.170990839535343,
    name: "Apotheek Rummen",
    address: "Kraaistraat 7A, 3454 Geetbets",
    website: "https://rummen.apotheek.be/",
    phone: "011 58 40 58"
  },
  {
    latitude: 51.246688561698726,
    longitude: 5.117040472284775,
    name: "Milk Bar",
    address: "Edmond van Hoofstraat 6, 2400 Mol",
    website: "https://milk-bar.be/?utm_source=google&utm_medium=cpc&utm_campaign=spring_sale&utm_term=162309606858-milkbar%20mol-b&utm_content=697188759245&gad_source=1&gclid=CjwKCAjwrIixBhBbEiwACEqDJUknyy_Z-BnHkxWfaMw9uqCP23-UHZ5oHushLkiPIVsjhvoXZm9lzxoCBP0QAvD_BwE",
    phone: "0475 30 06 12"
  },
  {
    latitude: 51.208439794194717,
    longitude: 4.053634505321086,
    name: "MaeMua",
    address: "Dorpsstraat 77C, 9190 Stekene",
    website: "https://maemua.be/",
    phone: "0495 78 42 17"
  },
  {
    latitude: 51.326283103167491,
    longitude: 4.94967581980868,
    name: "Apotheek De Meester",
    address: "Herentalsstraat 44, 2300 Turnhout",
    website: "https://apotheekdemeester.be/",
    phone: "014 41 23 67"
  },
  {
    latitude: 50.996948703084641,
    longitude: 3.272598880946123,
    name: "Blend Make-up",
    address: " Ter Ooigem 10, 8740 Pittem",
    website: "",
    phone: "0499 46 93 11"
  },
  {
    latitude: 51.174168583644757,
    longitude: 4.360680394824006,
    name: "Ma Belle Boetiek",
    address: "Heidestraat 98, 2660 Antwerpen",
    website: "https://mabelleboetiek.be/",
    phone: "0485 66 69 61"
  },
  {
    latitude: 51.030689296306818,
    longitude: 3.126488171442215,
    name: "Belle Liese",
    address: "Europalaan 25, 8810 Lichtervelde",
    website: "https://www.laserontharing.be/instituut/west-vlaanderen/lichtervelde/belle-liese",
    phone: "0479 22 97 84"
  },
  {
    latitude: 51.218437420740692,
    longitude: 4.4019984,
    name: "Europa Apotheek",
    address: "Groenplaats 42 2000 Antwerpen",
    website: "https://apotheekmees.be/europa-apotheek/",
    phone: "03 233 26 27"
  },
  {
    latitude: 50.883725325454009,
    longitude: 5.352361899999999,
    name: "Apotheek Wimmertingen",
    address: "Luikersteenweg 709 3501 Wimmertingen",
    website: "https://apotheekmees.be/apotheek-mees-wimmertingen/",
    phone: "011 37 75 59"
  },
  {
    latitude: 50.978608129816934,
    longitude: 5.343202722974105,
    name: "Loqual",
    address: "Quartier Bleu, Gelatineboulevard 4, 3500 Hasselt",
    website: "https://www.quartierbleu.be/",
    phone: "03 755 66 46"
  },
  {
    latitude: 50.932243949561141,
    longitude: 5.337955155822702,
    name: "Apotheek Huys",
    address: "Demerstraat 38 3500 Hasselt",
    website: "https://apotheekmees.be/apotheek-huys-van-hecke/",
    phone: "011 22 38 44"
  },
  {
    latitude: 51.051417628742492,
    longitude: 3.939661860158212,
    name: "Diff\u00e9rence Overmere",
    address: "Baron Tibbautstraat 49, 9290 Berlare",
    website: "https://salondifference.be/contact/",
    phone: "093602045"
  },
  {
    latitude: 51.091691074228827,
    longitude: 5.58729358502691,
    name: "Apotheek Melotte",
    address: "Ophovenstraat 11, 3670 Oudsbergen",
    website: "https://www.apotheekmelotte.be/",
    phone: "089 85 48 15"
  },
  {
    latitude: 50.983368976243185,
    longitude: 5.018019632695124,
    name: "Apotheek De Loore",
    address: "Diestersteenweg 241, 3293 Diest",
    website: "https://apotheekkaggevinne.be/apotheek-julie-de-loore/",
    phone: "013 33 39 17"
  },
  {
    latitude: 51.330775812580114,
    longitude: 4.420057759238136,
    name: "Apotheek De Linden",
    address: "Kapelsestraat 104, 2950 Kapellen",
    website: "https://www.apotheekdelinden.be/",
    phone: "03 755 07 11"
  },
  {
    latitude: 50.748834894185237,
    longitude: 3.608765819875661,
    name: "Apotheek Verpraet",
    address: "Heidestatiestraat 23, 2920 Kalmthout",
    website: "https://www.apotheekverpraet.be/",
    phone: "03 666 82 65"
  },
  {
    latitude: 50.747748743895912,
    longitude: 3.609452465358103,
    name: "Apotheek Platteeuw",
    address: "Elzelestraat 102, 9600 Ronse",
    website: "https://www.apotheekverpraet.be/",
    phone: "055 21 16 86"
  },
  {
    latitude: 50.818987386980055,
    longitude: 3.188978358116993,
    name: "Apotheek Polet",
    address: "Gullegemstraat 178, 8560 Wevelgem",
    website: "https://www.apotheekpolet.be/",
    phone: "056 32 35 22"
  },
  {
    latitude: 50.818854660581998,
    longitude: 3.189170813884215,
    name: "De Witte Mol",
    address: "Galbergen 21, 2400 Mol",
    website: "https://www.dewittemol.be/nl_BE/",
    phone: "014 34 63 70"
  },
  {
    latitude: 51.221484426998153,
    longitude: 4.417320358406241,
    name: "Pardaf",
    address: "Gemeentestraat 8, 2060 Antwerpen",
    website: "https://pardaf.be/",
    phone: "03 232 60 40"
  },
  {
    latitude: 50.937239676354814,
    longitude: 4.909613189871888,
    name: "Apotheek Tambeur",
    address: "Blerebergstraat 16, 3390 Tielt-Winge",
    website: "https://apotheektambeurtielt.be/",
    phone: "016 64 08 29"
  },
  {
    latitude: 50.906749388026022,
    longitude: 3.40457845092243,
    name: "Apotheek Vijve",
    address: "Aloise Biebuyckstraat 13, 8793 Waregem",
    website: "https://www.apotheekvijve.be/nl",
    phone: "056 60 27 88"
  },
  {
    latitude: 50.914459304345201,
    longitude: 4.73623043558251,
    name: "Apotheek Philips-Verstappen",
    address: "Leuvensebaan 161, 3220 Holsbeek",
    website: "http://www.apotheekphilipsverstappen.be/",
    phone: "016 44 46 77"
  },
  {
    latitude: 50.750396285827684,
    longitude: 3.600182797231382,
    name: "Apotheek Sarah Haentjens",
    address: "Peperstraat 10, 9600 Ronse",
    website: "https://www.desocialekaart.be/fiches/606827/algemeen",
    phone: "055 21 20 57"
  },
  {
    latitude: 51.072954599581941,
    longitude: 3.76464540821474,
    name: "Apotheek Casneuf",
    address: "Antwerpsesteenweg 595, 9040 Gent",
    website: "https://www.apotheekcasneuf.be/",
    phone: "09 228 18 21"
  },
  {
    latitude: 51.189922663848698,
    longitude: 4.430859647305127,
    name: "Apotheek Verdonck",
    address: "Lappersbrug 21, 2600 Antwerpen",
    website: "https://apotheekverdonck.be/",
    phone: "03 230 03 43"
  },
  {
    latitude: 50.913185525986385,
    longitude: 4.88170394209923,
    name: "Apotheek Sint-Joris",
    address: "Leuvensesteenweg 198, 3390 Tielt-Winge",
    website: "https://apotheeksintjoris.be/nl",
    phone: "016 63 48 10"
  },
  {
    latitude: 50.996412529687028,
    longitude: 4.55489147011156,
    name: "Apotheek Hever",
    address: "Hoogstraat 15, 3191 Boortmeerbeek",
    website: "https://apotheekbossers.be/apotheekhever/",
    phone: "015 51 61 22"
  },
  {
    latitude: 50.851323881450483,
    longitude: 3.445793992712058,
    name: "Kapsalon C\u00e9line",
    address: "Klokketuin 61, 8570 Anzegem",
    website: "https://www.kapsaloncelineanzegem.be/",
    phone: "0474 78 82 74"
  },
  {
    latitude: 50.907071687087253,
    longitude: 4.623157317477269,
    name: "Studio Zacht",
    address: "Gladiolenlaan 4, 3020 Herent",
    website: "https://www.studiozacht.be/",
    phone: "+32 476 57 96 43"
  },
  {
    latitude: 51.306150393195622,
    longitude: 4.734307030334393,
    name: "Apotheek Medimalle",
    address: "Hoogstraatsebaan 9, 2390 Malle, Belgi\u00eb",
    website: "https://www.medimalle.be/",
    phone: "+32 3 312 16 31"
  },
  {
    latitude: 51.010398379599941,
    longitude: 4.515975604898566,
    name: "Apotheek Muizen",
    address: "Magdalenasteenweg 52, 2812 Mechelen, Belgi\u00eb",
    website: "http://www.apotheekmuizen.be/",
    phone: "+3215416900"
  },
  {
    latitude: 51.195203240116726,
    longitude: 4.812587155207445,
    name: "Hidrodoe",
    address: "Haanheuvel 7, 2200 Herentals, Belgi\u00eb",
    website: "https://www.hidrodoe.be/",
    phone: "+32 14 44 26 44"
  },
  {
    latitude: 50.803018148470557,
    longitude: 5.843554834936115,
    name: "Schoonheidssalon Rachel",
    address: "Reijmerstokkerdorpsstraat 43 6274 NH Reijmerstok",
    website: "https://schoonheidssalon-rachel.jimdosite.com/",
    phone: "0616088296"
  },
  {
    latitude: 50.868121601201587,
    longitude: 4.709673746365707,
    name: "Apotheek Delendeker",
    address: "Pakenstraat 5, 3001 Leuven, Belgi\u00eb",
    website: "https://bizzy.org/nl/be/0445165563/apotheek-delendeker",
    phone: "+32 16 40 50 17"
  },
  {
    latitude: 50.968015548831808,
    longitude: 5.501188109241546,
    name: "ChaBelle",
    address: "Rootenstraat 17, shopping 2, 3600 Genk, Belgi\u00eb",
    website: "",
    phone: "+32 89 62 17 99"
  },
  {
    latitude: 51.180242584292181,
    longitude: 4.827600845001657,
    name: "Van Eccelpoel",
    address: "Lierseweg 26, 2200 Herentals",
    website: "https://www.vaneccelpoel.be/",
    phone: "014 21 26 93"
  },
  {
    latitude: 50.916368893448116,
    longitude: 3.601021165046686,
    name: "Decaphar bv",
    address: "Ouwegemsesteenweg 82, 9750 Kruisem",
    website: "https://kruisem.be/decaphar-bv",
    phone: "09 384 13 49"
  },
  {
    latitude: 51.15654669657814,
    longitude: 4.497165029693433,
    name: "Apotheek Naveau-Smeets",
    address: "Liersesteenweg 90, 2547 Lint",
    website: "https://apotheeknaveau.be/nl",
    phone: "03 455 93 10"
  },
  {
    latitude: 51.130693191844585,
    longitude: 4.33707281915863,
    name: "Apotheek Centrum Schelle",
    address: "Provinciale Steenweg 95, 2627 Schelle",
    website: "https://apotheekcentrumschelle.be/",
    phone: "03 887 54 72"
  },
  {
    latitude: 50.983776038955135,
    longitude: 4.52977880103588,
    name: "Apotheek Kinget Schiplaken",
    address: "Bieststraat 302, 3191 Boortmeerbeek",
    website: "https://www.apotheek-kinget.be/apotheken/apotheek-kinget-schiplaken/",
    phone: "015 61 20 92"
  },
  {
    latitude: 50.889348219541056,
    longitude: 3.433295349618655,
    name: "Apotheek De Brabandere",
    address: "Holstraat 20, 8790 Waregem",
    website: "https://debrabanderewaregem.apotheek.be/",
    phone: "056 60 19 38"
  },
  {
    latitude: 50.849761206765741,
    longitude: 3.603413312932325,
    name: "Apotheek De Brabandere",
    address: "Markt 24, 9700 Oudenaarde",
    website: "https://debrabandereoudenaarde.apotheek.be/",
    phone: "055 30 50 50"
  },
  {
    latitude: 50.785949986592165,
    longitude: 3.440619024479742,
    name: "E-Fit Avelgem",
    address: "Yzerwegstraat 3, 8580 Avelgem",
    website: "https://efitavelgem.be/",
    phone: "0470 94 27 44"
  },
  {
    latitude: 51.181999227482244,
    longitude: 4.597542989490429,
    name: "Apotheek Van den Broeck",
    address: "Pertendonckstraat 49, 2520 Ranst",
    website: "https://www.apotheekvandenbroeck.be/",
    phone: "+3234855187"
  },
  {
    latitude: 50.776202468547908,
    longitude: 3.445897820632625,
    name: "Apotheek Vantieghem - Van Burm",
    address: "Kerkstraat 24, 8580 Avelgem",
    website: "https://www.facebook.com/apotheekvantieghemvanburm/",
    phone: "056 64 41 06"
  },
  {
    latitude: 50.767441569326543,
    longitude: 4.475696701555743,
    name: "Apotheek Stas",
    address: "Albert Biesmanslaan 8, 1560 Hoeilaart",
    website: "https://stashoeilaart.be/",
    phone: "02 657 13 35"
  },
  {
    latitude: 51.130053103727228,
    longitude: 3.025624575081697,
    name: "Apotheek Sabine Buyse",
    address: "Stationsstraat 41, 8480 Ichtegem",
    website: "https://www.apotheek-buyse.be/",
    phone: "059 29 92 25"
  },
  {
    latitude: 51.143649565296421,
    longitude: 3.13648422327567,
    name: "Apotheek Morlion",
    address: "Snellegemsestraat 14, 8210 Zedelgem",
    website: "https://mobiphar.be/",
    phone: "050 67 08 74"
  },
  {
    latitude: 50.779530496955125,
    longitude: 3.443268719149611,
    name: "Esthetiek Julie",
    address: "Doorniksesteenweg 39, 8580 Avelgem",
    website: "https://www.instagram.com/esthetiek_julie/",
    phone: "0478 72 24 82"
  },
  {
    latitude: 51.004422480848739,
    longitude: 3.32461973323493,
    name: "Bokaal",
    address: "Bruggestraat 19, 8700 Tielt",
    website: "https://vzwwop.com/wop-bokaal/",
    phone: "0473 72 98 83"
  },
  {
    latitude: 51.147390494517282,
    longitude: 4.956528061371063,
    name: "Optiphar Apotheek Geel",
    address: "Antwerpseweg 81 B, 2440 Geel",
    website: "https://optiphar.com/nl-be/",
    phone: "014 58 87 44"
  },
  {
    latitude: 51.315887032169769,
    longitude: 4.821755515344867,
    name: "Apotheek Meeusen in Beerse",
    address: "Oostmalseweg 102a, 2340 Beerse",
    website: "https://apotheekmeeusen.be/",
    phone: "014 61 82 29"
  },
  {
    latitude: 51.113438819893474,
    longitude: 3.704461709571148,
    name: "Wereld-Atelier",
    address: "Hoeksken 68, 9940 Evergem ",
    website: "https://wereld-atelier.dendries.be/homepage?fbclid=IwAR1Z4eWUA_fIOu_xseP6QQdoNdhBfq2i1fwdPnfYcv2pd9htpqiBNx8gv2k",
    phone: "09 253 47 02"
  },
  {
    latitude: 51.227291515731956,
    longitude: 4.915204142327567,
    name: "Little Planet K",
    address: "Tielensteenweg 452460 Kasterlee",
    website: "https://www.facebook.com/littleplanetk/",
    phone: ""
  },
  {
    latitude: 51.094087527575276,
    longitude: 3.017362230689732,
    name: "Apotheek Bekaert",
    address: "Engelstraat 62, 8480 Ichtegem",
    website: "",
    phone: "051 58 81 71"
  },
  {
    latitude: 50.818354611432831,
    longitude: 3.435655028835692,
    name: "Yoga With Nathalie",
    address: "Pastoor Verrieststraat 33, 8570 Ingooigem",
    website: "",
    phone: ""
  },
  {
    latitude: 50.932041616285538,
    longitude: 5.126286871164307,
    name: "LOT25",
    address: "Holakenstraat 25, 3545 Halen",
    website: "",
    phone: ""
  },
  {
    latitude: 51.396901671849704,
    longitude: 4.494199657671844,
    name: "Zeepkist",
    address: "Achterbroeksteenweg 173, 2920 Kalmthout",
    website: "",
    phone: ""
  },
  {
    latitude: 51.05162466336273,
    longitude: 4.774217084653729,
    name: "Apotheek Farma Booischot",
    address: "Dorpsstraat 109, 2221 Booischot",
    website: "https://apotheekpeeters-booischot.be",
    phone: "015 22 21 69"
  },
  {
    latitude: 50.84702296145089,
    longitude: 5.106969632995961,
    name: "Sereen Beauty + Deco",
    address: "Ossenwegstraat 10, 3440 Zoutleeuw",
    website: "https://www.facebook.com/SereenBeautyDeco/?locale=nl_NL",
    phone: "0495 04 31 20"
  },
  {
    latitude: 51.21787555884864,
    longitude: 3.257209651375897,
    name: "Apotheek Vandenbroecke",
    address: "Moerkerkse Steenweg 242, 8310 Brugge",
    website: "https://apotheekvandenbroeke.apotheek.be/",
    phone: "050 35 46 93"
  },
  {
    latitude: 51.312563198194738,
    longitude: 3.122664571136394,
    name: "Apotheek Soetkin Op De Be\u00e9ck",
    address: "Vredelaan 5, 8370 Blankenberge",
    website: "https://www.apotheekopdebeeck.be/",
    phone: "050 41 37 23"
  },
  {
    latitude: 51.072071362234041,
    longitude: 2.588854886507413,
    name: "Esthetiek Graziella",
    address: "Grensarbeidersstraat 3, 8660 Adinkerke",
    website: "",
    phone: "0475 20 63 43"
  },
  {
    latitude: 50.899298597118722,
    longitude: 3.40382088280615,
    name: "Apotheek Mahieu",
    address: "Roterijstraat 234, 8793 Waregem",
    website: "http://www.mahieuapotheek.be/waregem",
    phone: "056 607 366"
  },
  {
    latitude: 51.399420428361417,
    longitude: 4.501182521950955,
    name: "Apotheek Curavit",
    address: "Brasschaatsteenweg 33, 2920 Kalmthout",
    website: "https://apotheekcuravit.be/",
    phone: "03 666 49 46"
  },
  {
    latitude: 50.85488106382806,
    longitude: 3.357343974887995,
    name: "Apotheek Beke Debusschere",
    address: "Hoogstraat 43, 8540 Deerlijk",
    website: "https://apotheekbeke.be/",
    phone: "056 75 94 39"
  },
  {
    latitude: 51.342120998147315,
    longitude: 3.237776618376417,
    name: "Apotheek Desrumaux-Debruyne",
    address: "Stadhuisstraat 16, 8301 Knokke-Heist",
    website: "https://efarma.be/",
    phone: "050 51 22 51"
  },
  {
    latitude: 51.278234960742978,
    longitude: 3.224075291596858,
    name: "Apotheek Desrumaux-Debruyne",
    address: "Dorpsplein 10, 8380 Dudzele",
    website: "https://efarma.be/",
    phone: "050 59 93 77"
  },
  {
    latitude: 51.410377312758136,
    longitude: 4.595267629384218,
    name: "Apotheek Medigrex",
    address: "Bredabaan 403, 2990 Wuustwezel",
    website: "https://medigrex.be/",
    phone: "03 669 61 19"
  },
  {
    latitude: 51.298973432574471,
    longitude: 4.408287029580952,
    name: "Apotheek Rozemaai",
    address: "Jef van Hoofstraat 2, 2180 Ekeren",
    website: "https://apotheekrozemaai.be/",
    phone: "03 542 53 72"
  },
  {
    latitude: 51.432198180446022,
    longitude: 4.513710624272944,
    name: "Apotheek Nieuwmoer",
    address: "Nieuwmoer-Dorp 11, 2920 Kalmthout",
    website: "https://apotheeknieuwmoer.apotheek.be/",
    phone: "03 344 14 01"
  },
  {
    latitude: 51.407787324246648,
    longitude: 4.466290810292933,
    name: "Apotheek Vantieghem Moen",
    address: "Kerkstraat 15, 8552 Moen",
    website: "https://www.apotheekvantieghem-moen-heestert.be/",
    phone: "056 64 44 58"
  },
  {
    latitude: 50.787841875020952,
    longitude: 3.398735283336395,
    name: "Apotheek Kalmthout Veraart",
    address: "N122 383, 2920 Kalmthout",
    website: "https://www.apotheekveraart.be/",
    phone: "03 666 41 60"
  },
  {
    latitude: 51.210897642195391,
    longitude: 4.43167755564075,
    name: "Apotheek Leuridan",
    address: "Draakstraat 18, 2018 Antwerpen",
    website: "https://apotheekleuridan.apotheek.be/",
    phone: "03 230 63 29"
  },
  {
    latitude: 51.381036129494817,
    longitude: 4.759541234302907,
    name: "Apotheek De Schrijver",
    address: "Dorp 24, 2310 Rijkevorsel",
    website: "https://www.apotheek-deschrijver.be/",
    phone: "03 314 60 38"
  },
  {
    latitude: 51.134492166436068,
    longitude: 3.67545285292335,
    name: "Apotheek Mouton Sleidinge",
    address: "Weststraat 34, 9940 Evergem",
    website: "https://www.apotheekmouton.be/",
    phone: "09 357 20 50"
  },
  {
    latitude: 50.729481519120426,
    longitude: 4.241677013492925,
    name: "Optiphar Turnhout",
    address: "Sint Rochusstraat 132, 1500 Halle",
    website: "https://optiphar.com/nl-be/",
    phone: "+32 23 56 58 19"
  },
  {
    latitude: 51.375496988015769,
    longitude: 4.472651747286582,
    name: "Apotheek Veraart",
    address: "N122 383, 2920 Kalmthout",
    website: "https://www.apotheekveraart.be/",
    phone: "03 666 41 60"
  },
  {
    latitude: 51.471307018608719,
    longitude: 4.497911826523282,
    name: "Apotheek Boden",
    address: "Over d'Aa 228, 2910 Essen",
    website: "https://apotheekboden.be/nl",
    phone: "03 677 37 96"
  },
  {
    latitude: 51.272378773454982,
    longitude: 3.032082803260404,
    name: "Point Du Jour",
    address: "Driftweg 16, 8420 De Haan",
    website: "https://www.facebook.com/pointdujourdehaan/?locale=nl_NL",
    phone: "059 23 86 37"
  },
  {
    latitude: 51.06401498582381,
    longitude: 5.291690723824281,
    name: "Ilse de Beauté",
    address: "Rechtestraat 99, 3582 Beringen",
    website: "https://ilsedebeaute.be/",
    phone: "0494 16 98 03"
  },
  {
    latitude: 51.29817610970418,
    longitude: 4.690884221715582,
    name: "Apotheek De Zwaantjes",
    address: "Antwerpsesteenweg 281, 2390 Malle",
    website: "https://apotheekdezwaantjes.be/",
    phone: "03 312 02 37"
  },
  {
    latitude: 51.252639489841776,
    longitude: 4.497422509874903,
    name: "Grow & Glow bv",
    address: "Jozef Hendrickxstraat 12, 2900 Schoten",
    website: "",
    phone: "0472 38 26 68"
  },
  {
    latitude: 50.806592345361295,
    longitude: 3.917136330960123,
    name: "BeautInes",
    address: " Aalstsesteenweg 120, 9506 Smeerebbe-Vloerzegem",
    website: "https://salonkee.be/salon/beautines?fbclid=IwAR0AAqKnUK2d6suMbdkAx5wkQ3KH_DOZWKycuxxI4Mn59VsXrHqbsEHMh3E",
    phone: "0491 06 65 20"
  },
  {
    latitude: 51.062691834282631,
    longitude: 4.366696201834842,
    name: "DONAVI",
    address: "Mechelsesteenweg 31, 2830 Willebroek",
    website: "https://donavi.be/",
    phone: "03 772 74 46"
  },
  {
    latitude: 51.211622473564212,
    longitude: 4.04360765767161,
    name: "Ilse Samson Kinesitherapie",
    address: "Potaardestraat 20, 9190 Stekene",
    website: "https://www.kinepunttotalbodyconcept.be/",
    phone: "0494 30 36 55"
  },
  {
    latitude: 51.14299097566402,
    longitude: 4.683019352349731,
    name: "Apotheek Van den Broeck Bevel",
    address: "Nijlensesteenweg 37, 2560 Bevel",
    website: "https://www.apotheekvandenbroeck.be/",
    phone: "03 481 70 09"
  },
  {
    latitude: 50.92397822504897,
    longitude: 3.85843027047444,
    name: "Apotheek Van Der Cruyssen-Van Lysebeth",
    address: "Marktplein 8, 9520 Sint-Lievens-Houtem",
    website: "https://apotheekvandercruyssen.be/",
    phone: "053 62 36 85"
  },
  {
    latitude: 51.2078407811956,
    longitude: 4.52438397909174,
    name: "Apotheek Joosen",
    address: "Kaakstraat 1, 2160 Wommelgem",
    website: "https://apotheekjoosen.apotheek.be/",
    phone: ""
  },
  {
    latitude: 51.986115704115349,
    longitude: 5.910589185738854,
    name: "HELLO. urban jungle & store",
    address: "Klarestraat 1A, 6811 DP Arnhem, Nederland",
    website: "https://www.hello-store.nl/",
    phone: ""
  },
  {
    latitude: 50.922702005354004,
    longitude: 5.685821842328155,
    name: "Salon MIC - Rekem",
    address: "Steenweg 132, 3621 Lanaken",
    website: "https://www.salon-mic.be/contact/contactformulier",
    phone: "089 21 88 21"
  },
  {
    latitude: 51.068693160046124,
    longitude: 3.101273705506224,
    name: "Apotheek Pattyn",
    address: "Markt 12, 8820 Torhout",
    website: "https://bartpattyn.apotheek.be/",
    phone: "050 21 22 24"
  },
  {
    latitude: 51.066140505735532,
    longitude: 4.457204742328156,
    name: "Walem Apotheek - Walem",
    address: "Koning Albertstraat 58, 2800 Mechelen",
    website: "",
    phone: "015 20 56 22"
  },
  {
    latitude: 51.331182573988144,
    longitude: 4.955208073015531,
    name: "Aa.Pharma Turnhout",
    address: "Steenweg op Oosthoven 126/bus 1, 2300 Turnhout",
    website: "https://aapharma.be/",
    phone: "014 41 23 70"
  },
  {
    latitude: 51.119693258524876,
    longitude: 4.62779928835922,
    name: "Pennello di Millie",
    address: "Bastijnstraat 131, 2590 Berlaar",
    website: "",
    phone: "0493 50 05 77"
  },
  {
    latitude: 51.109250023157429,
    longitude: 5.231749663395331,
    name: "SEVERINE - ALIVE STYLE",
    address: "Leopoldsburgsesteenweg 1, 3971 Heppen",
    website: "https://alivestyle.be/",
    phone: ""
  },
  {
    latitude: 51.109117296759372,
    longitude: 5.231943325403293,
    name: "Newlook by Steffi",
    address: "Tessenderloseweg 17b, 3290, Deurne",
    website: "",
    phone: ""
  },
  {
    latitude: 51.11443964386487,
    longitude: 4.042238120166439,
    name: "Apotheek Van Damme",
    address: "Sousbeekstraat 76, 9250 Waasmunster",
    website: "",
    phone: "09 348 90 95"
  },
  {
    latitude: 50.83383655310675,
    longitude: 5.583256247532248,
    name: "Apotheek Vlijtingen | Charlotte",
    address: "Molenweg 72, 3770 Riemst",
    website: "",
    phone: "012 45 21 56"
  },
  {
    latitude: 51.063485066118737,
    longitude: 3.69527926931751,
    name: "Apotheek Gent Rooigemlaan",
    address: "Rooigemlaan 474, 9000 Gent",
    website: "",
    phone: "092279378"
  },
  {
    latitude: 51.080736153892474,
    longitude: 3.728730241416031,
    name: "Apotheek Gent Muide",
    address: "Meulesteedsesteenweg 339, 9000 Gent",
    website: "",
    phone: "09 251 01 11"
  },
  {
    latitude: 51.030319860876837,
    longitude: 4.473985549733973,
    name: "Apotheek De Bruycker Maryke",
    address: "Nieuwe Beggaardenstraat 37, 2800 Mechelen",
    website: "",
    phone: "015 26 15 51"
  },
  {
    latitude: 50.985938637042352,
    longitude: 4.937363157671844,
    name: "Apotheek Schuttershof - Scherpenheuvel-Zichem",
    address: "Lobbensestraat 313, 3272 Scherpenheuvel-Zichem",
    website: "",
    phone: "013 77 41 69"
  },
  {
    latitude: 50.797029412724633,
    longitude: 2.746213896297092,
    name: "Apotheek Desmet - Westouter",
    address: "Bellestraat 5, 8954 Heuvelland",
    website: "",
    phone: "057 44 57 73"
  },
  {
    latitude: 51.199037405868907,
    longitude: 3.791660198152823,
    name: "Apotheek COOP Zelzate West",
    address: "Assenedesteenweg 94/b2, 9060 Zelzate",
    website: "",
    phone: "093447689"
  },
  {
    latitude: 51.002604929137831,
    longitude: 3.64271221164078,
    name: "Apotheek Moentjens Katrien",
    address: "Keistraat 30, 9830 Sint-Martens-Latem",
    website: "",
    phone: "09 282 86 64"
  },
  {
    latitude: 51.050988445054827,
    longitude: 3.663936057670622,
    name: "Apotheek Drongen",
    address: "Drongenplein 13, 9031 Gent",
    website: "",
    phone: "092266410"
  },
  {
    latitude: 50.831806908913023,
    longitude: 3.663215257671844,
    name: "Apotheek Nachtergaele - Mater",
    address: "Hauwaart 40, 9700 Oudenaarde",
    website: "",
    phone: "055 45 58 91"
  },
  {
    latitude: 52.246612977797945,
    longitude: 5.620597713494066,
    name: "Pluk & Proef",
    address: "Schovenhorsterveldweg 6, 3881 PB Putten",
    website: "",
    phone: "+31683053022"
  },
  {
    latitude: 51.092252853647167,
    longitude: 3.817994213494067,
    name: "Apotheek Lochristi",
    address: "Antwerpsesteenweg 30, 9080 Lochristi",
    website: "",
    phone: "092740790"
  },
  {
    latitude: 50.795738927704996,
    longitude: 4.984103734390285,
    name: "Apotheek Rigo - Holsbeek",
    address: "Putstraat 65, 3300 Tienen",
    website: "",
    phone: "016 78 20 64"
  },
  {
    latitude: 51.134083397727714,
    longitude: 4.38807316931882,
    name: "Groenelle",
    address: "Kapellestraat 14a, 2630 Aartselaar",
    website: "https://www.groenelle.be/",
    phone: "04 78 78 24 18"
  },
  {
    latitude: 50.951631114160691,
    longitude: 2.85487891164078,
    name: "Apotheek Merkem",
    address: "Kouterstraat 51, 8650 Houthulst",
    website: "",
    phone: "051 54 53 33"
  },
  {
    latitude: 50.952077200183325,
    longitude: 2.854878911647967,
    name: "Apotheek Merkem",
    address: "Kouterstraat 51, 8650 Houthulst",
    website: "",
    phone: "051 54 53 33"
  },
  {
    latitude: 50.880643484790006,
    longitude: 4.711153500000002,
    name: "TOUT Conceptstore",
    address: "Bondgenotenlaan 104, 3000 Leuven",
    website: "https://toutconceptstore.com",
    phone: ""
  },
  {
    latitude: 50.798037938414964,
    longitude: 3.498742353965402,
    name: "Apotheek Van Symaeys",
    address: "Oudenaardsesteenweg 490, 8581 Avelgem",
    website: "https://www.apotheekvansymaeys.be/",
    phone: "055 38 98 71"
  },
  {
    latitude: 51.106428563806062,
    longitude: 3.9874665,
    name: "Apotheek Karen Lievens",
    address: "Stationsstraat 28, 9160 Lokeren",
    website: "https://apotheekkarenlievens.be/nl/",
    phone: "09 348 22 80"
  },
  {
    latitude: 50.965077286406235,
    longitude: 3.421144053973547,
    name: "Apotheek Verlinde",
    address: "Wontergemstraat 30, 8720 Dentergem",
    website: "https://apotheekverlinde.be/",
    phone: "051 63 30 62"
  },
  {
    latitude: 50.750904242257619,
    longitude: 4.615944530684303,
    name: "Apotheek Matthijs",
    address: "Leuvensebaan 53, 3040 Huldenberg",
    website: "https://apotheekmatthijs.be/",
    phone: "016 47 20 82"
  },
  {
    latitude: 50.882127075690455,
    longitude: 4.8423116,
    name: "Apotheek Karolien Vertommen",
    address: "Dorpskring 5, 3210 Lubbeek",
    website: "https://www.apotheekvertommen.be/",
    phone: "016 63 42 01"
  },
  {
    latitude: 51.212558694776654,
    longitude: 4.0714595,
    name: "Ergo Studio",
    address: "Voorhout 2, 9190 Stekene",
    website: "https://www.ergostudio.be/",
    phone: "03 789 03 10"
  },
  {
    latitude: 51.155934567446756,
    longitude: 4.447542894930612,
    name: "Apotheek Mar\u00e9chal",
    address: "Hovestraat 44, 2650 Edegem",
    website: "https://apotheekmarechal.apotheek.be/",
    phone: "03 457 44 04"
  },
  {
    latitude: 50.958815894562363,
    longitude: 3.608624746026454,
    name: "Apotheek Buyck",
    address: "Drapstraat 70, 9810 Nazareth",
    website: "https://buyck.apotheek.be/",
    phone: "09 385 49 32"
  },
  {
    latitude: 50.998883445066234,
    longitude: 3.322748538631397,
    name: "Apotheek Gunst",
    address: "Ieperstraat 51, 8700 Tielt",
    website: "https://procura.farmad.be/index.html#/?apb=371502/",
    phone: "051 40 03 01"
  },
  {
    latitude: 50.902569125479715,
    longitude: 3.653989469315698,
    name: "Apotheek Demeyere",
    address: "Strijpstraat 35, 9750 Zingem",
    website: "https://apotheekdemeyerezingem.apotheek.be/",
    phone: "09 384 21 48"
  },
  {
    latitude: 50.887346560491189,
    longitude: 3.239284653973547,
    name: "Apotheek Kasteelstraat",
    address: "Kasteelstraat 23, 8860 Lendelede",
    website: "https://www.apotheekkasteelstraat.be/",
    phone: "051 30 69 51"
  },
  {
    latitude: 50.838222374311883,
    longitude: 3.4041424,
    name: "Apotheek Vichte",
    address: "Oudenaardestraat 4/001, 8570 Anzegem",
    website: "https://apotheekvichte.apotheek.be/",
    phone: "056 77 74 70"
  },
  {
    latitude: 50.883903990634806,
    longitude: 3.353568815342151,
    name: "Apotheek Van Wynsberghe",
    address: "Liebaardstraat 130, 8792 Waregem",
    website: "https://apotheekvanwynsberghe.be/",
    phone: "056 71 22 66"
  },
  {
    latitude: 50.935706652825289,
    longitude: 3.463552269315698,
    name: "Apotheek Vandermarliere",
    address: "Grote Steenweg 116, 9870 Zulte",
    website: "https://apotheekvandermarliere.be/",
    phone: "09 388 82 53"
  },
  {
    latitude: 50.928865512314033,
    longitude: 3.787803169315702,
    name: "Apotheek Van Der Stuyft",
    address: "Vrijhem 22, 9860 Oosterzele",
    website: "https://vanderstuyft.apotheek.be/",
    phone: "09 362 08 66"
  },
  {
    latitude: 50.812162976142297,
    longitude: 3.626621682919155,
    name: "Apotheek De Splenter",
    address: "Etikhoveplein 14, 9680 Etikhove",
    website: "https://www.apotheekdesplenter.be/",
    phone: "055 31 49 78"
  },
  {
    latitude: 50.997202471578341,
    longitude: 3.099054492604944,
    name: "Apotheek Delbeke-Aerts",
    address: "Stationsstraat 25, 8830 Hooglede",
    website: "https://apotheekdelbeke.be/",
    phone: "051 22 71 19"
  },
  {
    latitude: 51.043576807236782,
    longitude: 5.306619877262793,
    name: "Apotheek Pharmaproducts",
    address: "Pastoor Paquaylaan 81, 3550 Heusden-Zolder",
    website: "https://pharmaproducts.be/",
    phone: "011 57 25 34"
  },
  {
    latitude: 51.053581675553012,
    longitude: 3.72376991534215,
    name: "knol&kool",
    address: "Heilige-Geeststraat 30, 9000 Gent",
    website: "https://www.knolkool.com/",
    phone: "09 278 55 62"
  },
  {
    latitude: 51.035033526986268,
    longitude: 3.803482077904205,
    name: "Apotheek Beirnaert",
    address: "Tramstraat 63, 9070 Destelbergen",
    website: "https://apotheekbeirnaert.be/",
    phone: "09 230 62 29"
  },
  {
    latitude: 51.143004034606236,
    longitude: 5.595914707412433,
    name: "Kreatos Bree",
    address: "Kruittorenwal 17, 3960 Bree",
    website: "https://www.kreatos.be/nl/salons/bree",
    phone: "089 38 06 88"
  },
  {
    latitude: 51.133834371864211,
    longitude: 3.304835546026452,
    name: "Instituut Maud",
    address: "RIETSTRAAT 31, 8730 BEERNEM",
    website: "https://www.instituutmaud.be/",
    phone: "0470 52 22 76"
  },
  {
    latitude: 51.323222966337198,
    longitude: 5.078761630684302,
    name: "Apotheek De Schutter",
    address: "Schutterstraat 4, 2370 Arendonk",
    website: "https://apo2370.be/",
    phone: "014 67 76 33"
  },
  {
    latitude: 51.00304419068253,
    longitude: 4.634849030684302,
    name: "Apotheek Salvia",
    address: "Lindenstraat 6, 3140 Keerbergen",
    website: "https://apotheeksalvia.be/",
    phone: "015 51 28 95"
  },
  {
    latitude: 50.833934566857671,
    longitude: 5.103968530687072,
    name: "Apotheek Humblet",
    address: "Grote Markt 14, 3440 Zoutleeuw",
    website: "https://www.apotheekhumblet.be/",
    phone: "011/78 24 01"
  },
  {
    latitude: 51.32138202204748,
    longitude: 5.089058361374146,
    name: "Verkoop je miskoop",
    address: "Vrijheid 62, 2370 Arendonk",
    website: "http://verkoopjemiskoop.be/",
    phone: "0499 27 83 93"
  },
  {
    latitude: 51.040781691881492,
    longitude: 5.095446425146139,
    name: "Apotheek Meelberghs",
    address: "Hasseltsebaan 51, 3290 Deurne bij Diest",
    website: "https://apotheekmeelberghs.apotheek.be/",
    phone: "013 66 22 11"
  },
  {
    latitude: 50.839860110102478,
    longitude: 4.916270230687073,
    name: "Apotheek Vissenaken",
    address: "Aarschotsesteenweg 615, 3300 Tienen",
    website: "https://apotheekvissenaken.be/nl",
    phone: "016 81 42 87"
  },
  {
    latitude: 51.056756669174938,
    longitude: 3.71575374603061,
    name: "Apotheek Roos",
    address: "Burgstraat 120, 9000 Gent",
    website: "https://www.companyweb.be/nl/0882042774/apotheek-roos",
    phone: "09 223 49 65"
  },
  {
    latitude: 51.131443078894151,
    longitude: 3.6042075,
    name: "Apotheek Lien Rijckaert",
    address: "Oude Staatsbaan 74, 9930 Lievegem",
    website: "https://www.apotheekrijckaert.be/",
    phone: "09 372 57 07"
  },
  {
    latitude: 50.951955540783615,
    longitude: 2.855200776717683,
    name: "Apotheek Merkem/",
    address: "Kouterstraat 51, 8650 Houthulst",
    website: "https://www.merkem.be/apotheek-merkem/",
    phone: "051 54 53 33"
  },
  {
    latitude: 50.919437762703552,
    longitude: 4.42013850793878,
    name: "MADlion/",
    address: "Steenkaai 44D, 1800 Vilvoorde",
    website: "https://www.madlion.be/",
    phone: "02 253 03 67"
  },
  {
    latitude: 51.060156343427579,
    longitude: 4.280038015343536,
    name: "Apotheek Louisette Maes",
    address: "Liezele-Dorp 82, 2870 Puurs-Sint-Amands",
    website: "https://apotheekmaesliezele.be/",
    phone: "03 889 92 93"
  },
  {
    latitude: 51.3438807413511,
    longitude: 3.258064284656463,
    name: "apotheek Nautilus",
    address: "Mimosastraat, 8301 Knokke-Heist",
    website: "https://www.openingsuren.vlaanderen/nautilus/8300-knokke-heist/mimosastraat-16",
    phone: "050 51 20 66"
  },
  {
    latitude: 50.868779995269776,
    longitude: 4.959394307404756,
    name: "Elbefar",
    address: "Tiensesteenweg 169, 3380 Glabbeek",
    website: "https://www.apotheekglabbeek.be/",
    phone: "016 77 78 33"
  },
  {
    latitude: 51.2463005677102,
    longitude: 4.460270584656463,
    name: "Deuzeldapotheek",
    address: "Andr\u00e9 Ullenslei 2, 2900 Schoten",
    website: "https://www.deuzeldapotheek.be/",
    phone: "03 645 82 00"
  },
  {
    latitude: 51.11221454493441,
    longitude: 4.377105768726234,
    name: "Apotheek Lindenbos",
    address: "Kastanjelaan 56, 2630 Aartselaar",
    website: "https://apotheeklindenbos.be/",
    phone: "03 888 06 81"
  },
  {
    latitude: 50.94624971223557,
    longitude: 3.123157715620815,
    name: "Apotheek Demeulenaere",
    address: "Noordstraat 32, 8800 Roeselare",
    website: "https://apotheekdemeulenaere.be/",
    phone: "051 20 00 10"
  },
  {
    latitude: 50.891422209802258,
    longitude: 3.711625238631397,
    name: "Apotheek De Prijck",
    address: "Latemdreef 8, 9630 Zwalm",
    website: "https://apotheekdeprijck.be/",
    phone: "055 49 70 34"
  },
  {
    latitude: 50.944845835939191,
    longitude: 4.974432784657849,
    name: "Apotheek Bekkevoort",
    address: "Staatsbaan 148, 3460 Bekkevoort",
    website: "https://bekkevoort.apotheek.be/",
    phone: "013 31 23 04"
  },
  {
    latitude: 50.926190182406657,
    longitude: 4.801406823289247,
    name: "Apotheek Balans",
    address: "Dutselstraat 45, 3220 Holsbeek",
    website: "https://apotheekbalans.apotheek.be/",
    phone: "016 20 00 14"
  },
  {
    latitude: 50.913472450161152,
    longitude: 4.658461707947095,
    name: "Apotheek Kinget Herent",
    address: "Mechelsesteenweg 678, 3020 Herent",
    website: "https://www.apotheek-kinget.be/",
    phone: "016 41 66 42"
  },
  {
    latitude: 51.218627963813262,
    longitude: 4.437392969315698,
    name: "Apotheek Van Puyvelde",
    address: "Helmstraat 162, 2140 Antwerpen",
    website: "https://www.apotheekvanpuyvelde.be/",
    phone: "03 235 67 70"
  },
  {
    latitude: 51.05392603141847,
    longitude: 3.7311324,
    name: "Apotheek Martin",
    address: "Reep 44, 9000 Gent",
    website: "https://apotheekreep.apotheek.be/",
    phone: "09 223 94 11"
  },
  {
    latitude: 51.016199163741867,
    longitude: 3.735377807395056,
    name: "Apotheek Van Gansbeke",
    address: "Ottergemsesteenweg Zuid 808, 9000 Gent",
    website: "https://apotheek-vangansbeke.be/",
    phone: "09 330 04 45"
  },
  {
    latitude: 50.769562585756645,
    longitude: 3.397920261368604,
    name: "Apotheek Vantieghem-Moen",
    address: "Kerkstraat 15,8552 Moen",
    website: "https://www.apotheekvantieghemmoen.be/nl/",
    phone: "056 64 44 58"
  },
  {
    latitude: 50.905135114368939,
    longitude: 3.653146238079358,
    name: "Apotheek Greet Vanmeirhaeghe",
    address: "Alfred Amelotstraat 22, 9750 Zingem",
    website: "https://intro.apotheekvanmeirhaeghe.be/intro/",
    phone: "09 384 12 88"
  },
  {
    latitude: 51.200119127881152,
    longitude: 4.399983484657849,
    name: "Apotheek Markgrave",
    address: "Markgravelei 32, 2018 Antwerpen",
    website: "https://www.apotheekmarkgrave.be/",
    phone: "03 237 23 16"
  },
  {
    latitude: 50.95281256793659,
    longitude: 5.195628584659922,
    name: "Atelier Robijns",
    address: "Sint-Jorislaan 124, 3540 Herk-de-Stad",
    website: "https://pand56.be/",
    phone: "0456 56 51 77"
  },
  {
    latitude: 50.948567919704047,
    longitude: 3.290674484657849,
    name: "Apotheek Leupe",
    address: "Oostrozebekestraat 37, 8760 Meulebeke",
    website: "",
    phone: "051 48 88 89"
  },
  {
    latitude: 50.867842471143589,
    longitude: 3.635990999999999,
    name: "Apotheek Els Appelmans",
    address: "Reytstraat 9, 9700 Oudenaarde",
    website: "",
    phone: "055 30 90 38"
  },
  {
    latitude: 50.864680443345939,
    longitude: 2.902948169310268,
    name: "Apotheek St-Jan",
    address: "Brugseweg 208/210, 8900 Ieper",
    website: "https://www.apotheekst-jan.be/",
    phone: "057 20 57 41"
  },
  {
    latitude: 50.8446322404385,
    longitude: 5.425779057672456,
    name: "De kleinste dingen",
    address: "Loostraat 53, 3724 Vliermaal",
    website: "https://www.kleinstedingen.be",
    phone: ""
  },
  {
    latitude: 50.737580302545197,
    longitude: 4.237474346034735,
    name: "EVA!",
    address: "Klinkaert 1, 1500 Halle",
    website: "https://www.evainterieur.be",
    phone: "0476 22 39 05"
  },
  {
    latitude: 51.051371310715901,
    longitude: 3.7113848,
    name: "Apotheek Blindeman Ciska Gent",
    address: "Papegaaistraat 80, 9000 Gent",
    website: "",
    phone: "09 225 09 20"
  },
  {
    latitude: 51.163380707701208,
    longitude: 4.147965025908977,
    name: "Herbonat'ure",
    address: "Kalkstraat 70, 9100 Sint-Niklaas",
    website: "",
    phone: "0471 30 33 68"
  },
  {
    latitude: 50.959208649076771,
    longitude: 4.141205723293821,
    name: "Huis van Trinette",
    address: "Seepscherf 32, 9310 Aalst",
    website: "",
    phone: "0477 59 94 81"
  },
  {
    latitude: 51.029623603880914,
    longitude: 4.066537513491316,
    name: "Apotheek De Witte - De Sutter",
    address: "Zandstraat 92, 9200 Appels",
    website: "https://apotheekdwds.be",
    phone: "052 21 41 98"
  },
  {
    latitude: 51.031946044701087,
    longitude: 4.0883804,
    name: "Apotheek De Witte - De Sutter",
    address: "Gentsesteenweg 5, 9200 Dendermonde",
    website: "https://apotheekdwds.be",
    phone: "052 21 16 30"
  },
  {
    latitude: 51.250900404048082,
    longitude: 4.083037469310175,
    name: "Apotheek Heirbaut",
    address: "Bergstraat 39, 9170 Sint-Gillis-Waas",
    website: "https://apotheekheirbaut.apotheek.be",
    phone: "03 234 33 69"
  },
  {
    latitude: 50.794648267549078,
    longitude: 3.519738715344912,
    name: "Apotheek Greet Vanmeirhaeghe",
    address: "Pontstraat 53, 9690 Kluisbergen",
    website: "https://intro.apotheekvanmeirhaeghe.be",
    phone: "055 38 74 74"
  },
  {
    latitude: 50.854292362666094,
    longitude: 3.512214230689824,
    name: "Apotheek Annick Casier",
    address: "Oudenaardseweg 20/N494, 9790 Wortegem-Petegem",
    website: "https://apotheekwortegem.apotheek.be",
    phone: "056 68 91 80"
  },
  {
    latitude: 50.813114243897523,
    longitude: 3.336448930689825,
    name: "Apotheek Glorieux",
    address: "Otegemstraat 42, 8550 Zwevegem",
    website: "https://www.apotheekglorieux.be",
    phone: "056 75 52 74"
  },
  {
    latitude: 50.805973088301741,
    longitude: 3.237355846034737,
    name: "Apotheek Arie \u2013 Marke",
    address: "Kloosterstraat 55, 8510 Kortrijk",
    website: "http://www.apotheek-arie.be/#apotheek-openingsuren",
    phone: "056 21 76 77"
  },
  {
    latitude: 50.934093727783441,
    longitude: 3.153302415344912,
    name: "Apotheek Sofie Verhaeghe",
    address: "Rumbeeksesteenweg 477, 8800 Roeselare",
    website: "https://www.sofieverhaeghe.be",
    phone: "051 20 32 13"
  },
  {
    latitude: 51.322012575872911,
    longitude: 5.090238915344912,
    name: "Apotheek De Vrijheid",
    address: "Vrijheid 71, 2370 Arendonk",
    website: "https://apotheekdevrijheid.be",
    phone: "014 67 76 63"
  },
  {
    latitude: 51.317863744330417,
    longitude: 4.984114215344913,
    name: "Aa.Pharma Oud-Turnhout",
    address: "Steenweg op Mol 34/7, 2360 Oud-Turnhout",
    website: "https://aapharma.be/team/oud-turnhout/",
    phone: "014 45 24 29"
  },
  {
    latitude: 50.77520464459031,
    longitude: 3.437736199999999,
    name: "Planty Things",
    address: "Hoogstraat 54, 8580 Avelgem",
    website: "https://www.plantythings.be",
    phone: "04 71 41 71 38"
  },
  {
    latitude: 51.021555399809181,
    longitude: 3.719951469310268,
    name: "Apotheek De Loof",
    address: "Zwijnaardsesteenweg 718, 9000 Gent",
    website: "https://farmaweb.be/",
    phone: "09 222 42 03"
  },
  {
    latitude: 44.669389646986019,
    longitude: 0.397599271163784,
    name: "L'usine",
    address: "Rue de la sole 22, 24500 Eymet",
    website: "https://www.lusine-eymet.fr/",
    phone: "06\u202f70\u202f24\u202f44\u202f19"
  },
  {
    latitude: 51.000495481418994,
    longitude: 4.091540853965402,
    name: "Apobelle",
    address: "Kapellenstraat 57, 9280 Lebbeke",
    website: "https://www.apobelle.be/",
    phone: "052575437"
  },
  {
    latitude: 50.863180462953551,
    longitude: 4.711608415339957,
    name: "Apotheek Cleeremans",
    address: "Pakenstraat 5, 3001 Leuven",
    website: "",
    phone: "016405017"
  },
  {
    latitude: 50.740026012492407,
    longitude: 3.603875200000001,
    name: "Apotheek Glibert-Lox",
    address: "Jules Bordetlaan 32, 9600 Ronse",
    website: "http://www.apotheekglibert.be/",
    phone: "055206870"
  },
  {
    latitude: 50.850887869113144,
    longitude: 3.2701128732119487,
    name: "Apotheek De Cuypere",
    address: "Brugsesteenweg 96, 8520 Kuurne",
    website: "https://apotheekdecuypere.apotheek.be/",
    phone: "056353007"
  },
  {
    latitude: 50.86268883283815,
    longitude: 3.3037057259758673,
    name: "Apotheek Raes",
    address: "Overleiestraat 117, 8530 Harelbeke",
    website: "https://www.apotheekraesharelbeke.be/",
    phone: "056 71 13 91"
  },
  {
    latitude: 50.84000007248779,
    longitude: 3.1648205,
    name: "Apotheek Goethals",
    address: "Secretaris Vanmarckelaan 3, 8560 Wevelgem",
    website: "http://apotheekgoethals-dedeene.be/",
    phone: "056411114"
  },
  {
    latitude: 50.778624558112412,
    longitude: 3.2297885,
    name: "Apotheek d pharma",
    address: "Moeskroensesteenweg 81, 8511 Kortrijk",
    website: "http://www.apotheekdpharma.be/",
    phone: "056413681"
  },
  {
    latitude: 51.155990110527597,
    longitude: 3.597666653980126,
    name: "Dorpsapotheek Waarschoot",
    address: "G. Gezellelaan 8, 9950 Lievegem",
    website: "http://www.dorpsapotheekwaarschoot.be/home",
    phone: "093771079"
  },
  {
    latitude: 51.177160254162366,
    longitude: 3.933675384660042,
    name: "Schoonheidssalon Lim\u00e9e",
    address: "Heidewegel 54, 9180 Moerbeke",
    website: "https://limee.be/",
    phone: "0468 23 87 15"
  },
  {
    latitude: 50.887487771872003,
    longitude: 3.427384784660042,
    name: "Floww",
    address: "Molenstraat 31, 8790 Waregem",
    website: "https://www.findyourfloww.be/",
    phone: "0489 56 65 54"
  },
  {
    latitude: 51.174805492452528,
    longitude: 3.939676130679916,
    name: "Apotheek Van Der Weken",
    address: "Bevrijdersstraat 34, 9180 Moerbeke",
    website: "https://apotheekvanderweken.apotheek.be/",
    phone: "093468109"
  },
  {
    latitude: 51.248333688526344,
    longitude: 2.961587984660042,
    name: "Apotheek Duinen",
    address: "Duinenstraat 373, 8450 Bredene",
    website: "http://www.apotheekduinen.be/",
    phone: "059323634"
  },
  {
    latitude: 50.948324487229861,
    longitude: 4.0979842,
    name: "Apotheek Kelles",
    address: "Moorsel-Dorp 21, 9310 Aalst",
    website: "https://www.apotheekkelles.be/",
    phone: "053779989"
  },
  {
    latitude: 50.810203118859683,
    longitude: 3.474258153980127,
    name: "Apotheek Loosveldt",
    address: "Kapellestraat 9, 8573 Anzegem",
    website: "https://www.apotheekopzak.be/apotheek-loosveldt",
    phone: "056688317"
  },
  {
    latitude: 52.273849620720704,
    longitude: 5.159479784660043,
    name: "All Brows",
    address: "Herenstraat 14, 1406 PE Bussum, Nederland",
    website: "http://www.allbrows.nl/",
    phone: "+31654972607"
  },
  {
    latitude: 50.95017924637488,
    longitude: 3.805264769320085,
    name: "Apotheek De Wael",
    address: "Voordries 11, 9860 Oosterzele",
    website: "http://www.apotheekoosterzele.be/",
    phone: "093628858"
  },
  {
    latitude: 51.053333020408274,
    longitude: 3.724470446019875,
    name: "Just Feel Good shop",
    address: "Bennesteeg 1A, 9000 Gent",
    website: "https://www.justfeelgoodshop.com/",
    phone: ""
  },
  {
    latitude: 50.992023714916449,
    longitude: 3.759521969320084,
    name: "Apotheek Van Houtte",
    address: "Lembergsesteenweg 132, 9820 Merelbeke",
    website: "https://www.apotheekvanhoutte.be/",
    phone: "093368866"
  },
  {
    latitude: 51.182421928458112,
    longitude: 3.571595283392237,
    name: "Apotheek Claus",
    address: "Stationsstraat 78, 9900 Eeklo",
    website: "https://claus.apotheek.be/",
    phone: "093771882"
  },
  {
    latitude: 51.05105207935916,
    longitude: 4.1074947,
    name: "Goethals Debrabandere Apotheek",
    address: "Dokter Haekstraat 64, 9200 Dendermonde",
    website: "https://apotheekgoethals.be",
    phone: "052 21 14 19"
  },
  {
    latitude: 50.871098040530612,
    longitude: 5.516753611096784,
    name: "ve-time",
    address: "Passage 7, 3740 Bilzen",
    website: "https://ve-time.be",
    phone: "0498125001"
  },
  {
    latitude: 50.842399785335424,
    longitude: 3.203870861367118,
    name: "Apotheek Vander Stichele",
    address: "Kon. Fabiolastraat 17, 8560 Wevelgem",
    website: "https://www.apotheekvanderstichele.be",
    phone: "056 41 21 06"
  },
  {
    latitude: 51.182933076249974,
    longitude: 3.571391438640169,
    name: "Apotheek Claus",
    address: "Stationsstraat 78, 9900 Eeklo",
    website: "https://claus.apotheek.be/",
    phone: "09 377 18 82"
  },
  {
    latitude: 50.842440434022386,
    longitude: 3.203742115339958,
    name: "Apotheek Vander Stichele",
    address: "Kon. Fabiolastraat 17, 8560 Wevelgem",
    website: "https://www.apotheekvanderstichele.be/",
    phone: "056 41 21 06"
  },
  {
    latitude: 51.002359471272179,
    longitude: 3.884379939817566,
    name: "Apotheek Ducastel - De Smet",
    address: "Stationsstraat 71, 9230 Wetteren",
    website: "https://ducastel.apotheek.be/",
    phone: "09 369 16 99"
  },
  {
    latitude: 51.178787417304278,
    longitude: 3.753916484660042,
    name: "Apotheek Health and Beauty Shop",
    address: "Pastorijstraat 70, 9940 Evergem",
    website: "https://feelgoodcare.be/apotheek-health-and-beauty/",
    phone: "09 396 91 73"
  },
  {
    latitude: 51.056344934651648,
    longitude: 3.283939069320084,
    name: "Apotheek De Loore",
    address: "Tieltstraat 66, 8750 Wingene",
    website: "https://apotheekdeloore.be/",
    phone: "051 65 51 15"
  },
  {
    latitude: 50.976738720167212,
    longitude: 4.919840892039747,
    name: "Ghibli Beauty",
    address: "Diestsesteenweg 587, 3202 Aarschot",
    website: "https://www.arclothing.be/",
    phone: "016 57 33 59"
  },
  {
    latitude: 50.988085513995998,
    longitude: 3.797663284660042,
    name: "Apotheek Rhode",
    address: "Geraardsbergsesteenweg 66, 9090 Melle",
    website: "http://www.apotheekkarenpieters.be/",
    phone: "09 252 20 90"
  },
  {
    latitude: 51.1548682855911,
    longitude: 5.594816293277102,
    name: "Bel&Bo Bree",
    address: "Bocholterkiezel 81, 3960 Bree",
    website: "https://www.belenbo.be/",
    phone: "089 77 77 35"
  },
  {
    latitude: 51.102130655916049,
    longitude: 3.104276731885026,
    name: "Amalya",
    address: "Aartrijksestraat 165, 8211 Aartrijke",
    website: "https://www.amalya.be/",
    phone: "050 21 58 73"
  },
  {
    latitude: 51.101997929517992,
    longitude: 3.1044703640667,
    name: "Amalya",
    address: "Aartrijksestraat 165, 8211 Aartrijke",
    website: "https://www.amalya.be/",
    phone: "050 21 58 73"
  },
  {
    latitude: 51.201996223403661,
    longitude: 2.97507622330021,
    name: "Apotheek Sielke Puype",
    address: "Kasteelstraat 2, 8400 Oostende",
    website: "https://apotheekzandvoorde.be/",
    phone: "059 26 83 17"
  },
  {
    latitude: 50.807936206927934,
    longitude: 3.342664546019873,
    name: "Apotheek Anne-Sophie Mullie",
    address: "Engelandlaan 1, 8550 Zwevegem",
    website: "",
    phone: "056 75 60 17"
  },
  {
    latitude: 50.819977702525655,
    longitude: 3.472879807379705,
    name: "Picass",
    address: "Doornstraat 2, 8573 Anzegem",
    website: "https://www.picass.be/",
    phone: "056 61 07 82"
  },
  {
    latitude: 51.101231092206561,
    longitude: 3.608094259840211,
    name: "Rem\u00e9di Apotheek",
    address: "Molendreef 10, 9920 Lievegem",
    website: "https://www.remedi-apotheek.be/",
    phone: "09 372 71 39"
  },
  {
    latitude: 50.930990124148131,
    longitude: 3.397979361359831,
    name: "Apotheek De Bus Wakken",
    address: "Wapenplaats 10, 8720 Dentergem",
    website: "https://apotheekwakken.be/",
    phone: "056 60 22 30"
  },
  {
    latitude: 50.860509342921958,
    longitude: 3.362605461359831,
    name: "Apotheek Viaene",
    address: "Driesknoklaan 25, 8540 Deerlijk",
    website: "https://apotheekviaene.be/",
    phone: "056 71 54 08"
  },
  {
    latitude: 51.042880379545302,
    longitude: 3.733995890878653,
    name: "Leveugle",
    address: "Franklin Rooseveltlaan 505, 9000 Gent",
    website: "https://www.apothekenganda.be/",
    phone: "09 223 46 71"
  },
  {
    latitude: 51.048359204453519,
    longitude: 3.730002344858779,
    name: "GANDA Apotheek De Krook De Belie",
    address: "Lammerstraat 37, 9000 Gent",
    website: "https://www.apothekenganda.be/",
    phone: "09 225 20 39"
  },
  {
    latitude: 51.039067850568571,
    longitude: 3.732246605638063,
    name: "GANDA Apotheek Ter Platen",
    address: "Tentoonstellingslaan 132, 9000 Gent",
    website: "https://www.apothekenganda.be/",
    phone: "09 225 20 24"
  },
  {
    latitude: 50.896499283357002,
    longitude: 4.701540169320085,
    name: "Apotheek Pharmanema",
    address: "Albert Woutersstraat 9, 3012 Leuven",
    website: "http://www.pharmanema.be/",
    phone: "016 23 40 53"
  },
  {
    latitude: 50.831299981431002,
    longitude: 4.023123699999999,
    name: "DaRoM",
    address: "Burchtdam 69, 9400 Ninove",
    website: "https://darom.be/",
    phone: "0471 60 54 59"
  },
  {
    latitude: 51.34109276825329,
    longitude: 3.245080173797051,
    name: "Apotheek Janssen",
    address: "Graaf d'Ursellaan 19, 8301 Knokke-Heist",
    website: "https://www.apotheekjanssenheist.be/",
    phone: "050 51 29 04"
  },
  {
    latitude: 51.097087246475063,
    longitude: 4.131285290878653,
    name: "ROOM 17",
    address: "Stationsstraat 31, 9220 Hamme",
    website: "http://www.room17.be/",
    phone: "0478 65 94 69"
  },
  {
    latitude: 52.331061672012218,
    longitude: 5.544289325963644,
    name: "De Winkeltjes",
    address: "Weergang 9a, 3891 GR\u00a0Zeewolde, Nederland",
    website: "https://www.dewinkeltjes-zeewolde.nl/",
    phone: "+31 6 24962676"
  },
  {
    latitude: 52.335849378912606,
    longitude: 5.517956206393595,
    name: "Speeltastisch",
    address: "Grote Beer 16, 3893 DK Zeewolde, Nederland",
    website: "https://www.speeltastisch.nl/",
    phone: "+31 6 12244653"
  },
  {
    latitude: 51.096157936577328,
    longitude: 3.831100622762083,
    name: "Cloud Nine",
    address: "Dorp-West 51/b01, 9080 Lochristi",
    website: "https://www.cloudninestore.be/",
    phone: "0468 36 77 88"
  },
  {
    latitude: 50.849560074042735,
    longitude: 3.601659158457093,
    name: "Apotheek Boulanger",
    address: "Beverestraat 50, 9700 Oudenaarde",
    website: "https://apotheekboulanger.be/",
    phone: "055 31 21 58"
  },
  {
    latitude: 50.813404231945277,
    longitude: 3.337030874377599,
    name: "Apotheek Sulmon",
    address: "Otegemstraat 5, 8550 Zwevegem",
    website: "https://apotheeksulmon.be/",
    phone: "056 75 52 79"
  },
  {
    latitude: 51.325416610073546,
    longitude: 3.301672804424189,
    name: "Apotheek Kalvekeetdijk",
    address: "Kalvekeetdijk 139, 8300 Knokke-Heist",
    website: "https://www.apotheekkalvekeetdijk.com/",
    phone: "050 60 08 58"
  },
  {
    latitude: 50.863640021380867,
    longitude: 5.104829221558568,
    name: "De Gelaarsde KAT: kinder- en damesschoenen",
    address: "Terweidenstraat 34/bus 1, 3440 Zoutleeuw",
    website: "https://www.schoenendegelaarsdekat.be/",
    phone: "0478 44 42 60"
  },
  {
    latitude: 50.744727539139731,
    longitude: 4.272004909489715,
    name: "Apotheek Vandersteen Huizingen",
    address: "Steenweg naar Alsemberg 952, 1654 Beersel",
    website: "https://apotheek-vandersteen-huizingen.business.site/",
    phone: "02 356 77 40"
  },
  {
    latitude: 50.901939299480162,
    longitude: 4.001163087281958,
    name: "Instituut Nieke",
    address: "Achterstraat 40, 9450 Haaltert",
    website: "https://www.instituut-nieke.be/",
    phone: "0496 03 77 65"
  },
  {
    latitude: 51.056186486041113,
    longitude: 4.105787222757819,
    name: "Apotheek Groeneweg",
    address: "Groeneweg 4, 9200 Dendermonde",
    website: "https://www.apotheekgroeneweg.be",
    phone: "052 52 50 56"
  },
  {
    latitude: 50.825643928620821,
    longitude: 5.455727156935634,
    name: "Beautybar Kellie",
    address: "Hernerweg 105, 3730 Hoeselt",
    website: "https://beautybarkellie.be/index.php",
    phone: "0479 64 58 86"
  },
  {
    latitude: 51.039140289879839,
    longitude: 3.633999305338915,
    name: "LIVINGDESIGN",
    address: "Deinsesteenweg 94, 9031 Gent",
    website: "https://www.livingdesign.be/nl/",
    phone: "09 273 98 80"
  },
  {
    latitude: 51.055851214035108,
    longitude: 3.72503770482037,
    name: "Apotheek Korenmarkt",
    address: "Kortemunt 6, 9000 Gent",
    website: "https://apotheekkorenmarkt.be",
    phone: "09 223 27 08"
  },
  {
    latitude: 51.071492269718568,
    longitude: 2.664797289994187,
    name: "J'Esthetiek",
    address: "Klaverstraat 28, 8630 Veurne",
    website: "https://www.jesthetiek.be",
    phone: "0474 09 89 23"
  },
  {
    latitude: 50.816996794972695,
    longitude: 3.437082613789095,
    name: "Apotheek Mylle",
    address: "Stijn Streuvelsstraat 26, 8570 Anzegem",
    website: "https://apotheekmylle.be",
    phone: "056 77 78 43"
  },
  {
    latitude: 51.125181466708518,
    longitude: 4.217605714268069,
    name: "Parfumerie-Schoonheidscentrum Hilde",
    address: "Kasteelstraat 34, 9140 Temse",
    website: "",
    phone: "03 771 02 76"
  },
  {
    latitude: 50.834434122301197,
    longitude: 5.598803860297854,
    name: "Pro Karo",
    address: "Bijsstraat 45, 3770 Riemst",
    website: "https://booking.optios.net/6703",
    phone: "0473 66 64 99"
  },
  {
    latitude: 51.007559856655661,
    longitude: 3.628580559760258,
    name: "Coiffure Magique",
    address: "Brandstraat 68/A, 9830 Sint-Martens-Latem",
    website: "https://www.magiquelatem.be/#xl_xr_page_index",
    phone: "09 281 08 05"
  },
  {
    latitude: 51.108605548585764,
    longitude: 4.005717844416997,
    name: "Wellnesst",
    address: "Bleekmeersstraat 66, 9160 Lokeren",
    website: "https://wellnesst.be",
    phone: "0478 79 83 32"
  },
  {
    latitude: 50.908789262201935,
    longitude: 5.060583752895022,
    name: "Apotheek Grauwels",
    address: "Tiensestraat 5, 3470 Kortenaken",
    website: "http://www.apotheekgrauwels.be",
    phone: "011 58 78 17"
  },
  {
    latitude: 50.923218411741473,
    longitude: 4.7208610188279,
    name: "Apotheek Adriaens",
    address: "Aarschotsesteenweg 604, 3012 Leuven",
    website: "https://apotheekadriaens.be",
    phone: "016 44 53 15"
  },
  {
    latitude: 50.981285705620124,
    longitude: 5.682267869313477,
    name: "Apotheek Pharmapoint",
    address: "Thomasboslaan 98, 3630 Maasmechelen",
    website: "https://pharmapoint.be",
    phone: "089 76 07 38"
  },
  {
    latitude: 50.994385812975672,
    longitude: 4.532838484656738,
    name: "Hendrix Ann",
    address: "Leuvensesteenweg 20, 3191 Boortmeerbeek",
    website: "https://pharmapoint.be/apotheek-ann-hendrix/",
    phone: "015 51 24 93"
  },
  {
    latitude: 51.032913775566549,
    longitude: 4.7579041,
    name: "Apotheek Pijpelheide",
    address: "Schrieksesteenweg 40, 2221 Heist-op-den-Berg",
    website: "https://apotheekpijpelheide.be/index.html",
    phone: "015 43 53 02"
  },
  {
    latitude: 50.820962531461049,
    longitude: 4.888229776716308,
    name: "Apotheek Kumtich",
    address: "Kumtichstraat 25, 3000 Tienen",
    website: "",
    phone: "016 69 94 15"
  },
  {
    latitude: 50.869311547502683,
    longitude: 4.707906646029786,
    name: "Apotheek Parkpoort",
    address: "Erasme Ruelensvest 191, 3001 Leuven",
    website: "https://www.apotheekparkpoort.be",
    phone: "016 23 98 37"
  },
  {
    latitude: 51.188463103139632,
    longitude: 2.815754761373047,
    name: "Apotheek Orbie",
    address: "Leopoldlaan 56, 8430 Middelkerke",
    website: "https://apotheekorbie.be",
    phone: "059 30 04 48"
  },
  {
    latitude: 51.046809295674599,
    longitude: 3.745093261373047,
    name: "Umber & Smoke",
    address: "Vlaamsekaai 125, 9000 Gent",
    website: "https://www.umberandsmoke.com",
    phone: "09 329 34 33"
  },
  {
    latitude: 51.210090590377604,
    longitude: 3.232907046029786,
    name: "KarmaMarkt",
    address: "Langestraat 22, 8000 Brugge",
    website: "https://www.karmamarkt.be",
    phone: "0476 21 14 49"
  },
  {
    latitude: 51.067914922488256,
    longitude: 3.093753198260194,
    name: "Apotheek Lieselot Goegebeur",
    address: "Oostendestraat 154, 8820 Torhout",
    website: "https://apotheekgoegebeur.be",
    phone: "050 21 19 77"
  },
  {
    latitude: 52.671279339615609,
    longitude: 4.847671507402833,
    name: "Cynthia's Beautysalon",
    address: "Middenweg 241A, 1701 GC Heerhugowaard, Nederland",
    website: "https://cynthiasbeautysalon.com",
    phone: "+31 6 43151430"
  },
  {
    latitude: 51.165548487685619,
    longitude: 4.141044582920501,
    name: "Familie Oliefant Pop Up",
    address: "Stationsstraat 10B, 9100 Sint-Niklaas",
    website: "https://www.familieoliefant.be/pop-up",
    phone: ""
  },
  {
    latitude: 51.056287231957889,
    longitude: 3.267525098259771,
    name: "Ecofantje",
    address: "Oude Bruggestraat 111, 8750 Wingene",
    website: "https://www.ecofantje.be",
    phone: "0498453918"
  },
  {
    latitude: 51.269327699885238,
    longitude: 3.034044709738848,
    name: "Beaut\u00e9 Nathurelle",
    address: "Bredeweg 17A, 8420 De Haan",
    website: "http://www.beautenathurelle.com/",
    phone: "0472999850"
  },
  {
    latitude: 51.304182144868527,
    longitude: 4.441700153921533,
    name: "Miss glamorous",
    address: "Lijsterlaan 27, 2950 Kapellen",
    website: "http://www.missglamorous.be/",
    phone: "0485204759"
  },
  {
    latitude: 51.012339274975993,
    longitude: 3.363482536703508,
    name: "Natuurhuis Pacha Mama",
    address: "Ruiseleedsesteenweg 55, 8700 Tielt",
    website: "https://www.natuurhuispachamama.be/",
    phone: "051409663"
  },
  {
    latitude: 51.02263269213082,
    longitude: 4.481669809720449,
    name: "Supergoods Mechelen",
    address: "Onze-Lieve-Vrouwestraat 116, 2800 Mechelen",
    website: "http://www.supergoods.be/",
    phone: "0486341255"
  },
  {
    latitude: 51.216601059391941,
    longitude: 4.395111553915002,
    name: "Supergoods Antwerpen",
    address: "Kloosterstraat 38, 2000 Antwerpen",
    website: "http://www.supergoods.be/",
    phone: "0476903707"
  },
  {
    latitude: 51.050394984466237,
    longitude: 3.729492240410658,
    name: "Inslag",
    address: "Brabantdam 63, 9000 Gent",
    website: "https://inslag.gent/",
    phone: "0468316320"
  },
  {
    latitude: 51.118274268921972,
    longitude: 3.941913980891531,
    name: "Beauty corner Sindy Vissers",
    address: "Doorslaardam 40/B, 9160 Lokeren",
    website: "http://www.beautycorner-sindyvissers.be/",
    phone: "0477433641"
  },
  {
    latitude: 53.164309548150605,
    longitude: 6.776985167554678,
    name: "Asmaria Cosmedisch",
    address: "Noorderstraat 17, 9611 AA Sappemeer, Nederland",
    website: "https://www.asmaria.nl/",
    phone: "+31620015626"
  },
  {
    latitude: 51.104273789279382,
    longitude: 5.867962338562508,
    name: "Brilliant Beauty",
    address: "Gelrestraat 46, 6101 EW Echt, Nederland",
    website: "https://www.facebook.com/BrilliantBeautyEcht/?locale=nl_NL",
    phone: "+31 6 83567202"
  },
  {
    latitude: 51.000127801538227,
    longitude: 3.325658667390785,
    name: "Apotheek Verfaillie",
    address: "Ieperstraat 5, 8700 Tielt",
    website: "http://www.apotheekverfaillie.be/",
    phone: "051400685"
  },
  {
    latitude: 53.057640792612943,
    longitude: 4.794303364417903,
    name: "Skin Happiness",
    address: "Schoonoordsingel 5A, 1791 EL Den Burg - Texel",
    website: "https://skinhappiness.nl/",
    phone: "+31651501894"
  },
  {
    latitude: 51.176442264356275,
    longitude: 4.315118738567899,
    name: "S.thetique",
    address: "Molenstraat 5, 9150 Kruibeke",
    website: "http://sthetique.be/",
    phone: "0486423666"
  },
  {
    latitude: 51.094028606381606,
    longitude: 3.993225552053723,
    name: "Apotheek Spoele",
    address: "Spoele 1, 9160 Lokeren",
    website: "https://www.apotheekspoele.be/",
    phone: "093487451"
  },
  {
    latitude: 51.101469313807193,
    longitude: 3.984531871147663,
    name: "Omnicare Farma - apotheek Gryson",
    address: "Vrijheidsplein 4, 9160 Lokeren",
    website: "http://www.omnicarefarma.be/",
    phone: "093481969"
  },
  {
    latitude: 51.056834374804758,
    longitude: 2.876691567395043,
    name: "Apotheek Vanlerberghe",
    address: "Oostendestraat 58, 8600 Diksmuide",
    website: "http://www.apotheekvanlerberghe.be/",
    phone: "051502205"
  },
  {
    latitude: 50.818855805256575,
    longitude: 5.825335753885362,
    name: "Salon Manon",
    address: "Sprinkstraat 30, 6269 AP Margraten, Nederland",
    website: "http://www.salonmanon.eu/",
    phone: "+31438528078"
  },
  {
    latitude: 51.602763804983127,
    longitude: 6.050820734895527,
    name: "Beautysalon Mirlou",
    address: "Murseltseweg 6, 5854 CW Bergen, Nederland",
    website: "http://www.beautysalonmirlou.nl/",
    phone: "+31628643628"
  },
  {
    latitude: 52.359813318629875,
    longitude: 6.663632523313032,
    name: "Go Glow Beauty & Nails",
    address: "Boddenstraat 66a, 7607 BN Almelo, Nederland",
    website: "https://goglowalmelo.nl/",
    phone: "+31683996784"
  },
  {
    latitude: 52.42949337482171,
    longitude: 4.91702898099036,
    name: "FIJN! Beauty & Massage",
    address: "Van Beekstraat 38, 1121 NP Landsmeer, Nederland",
    website: "https://www.fijn-beauty.nl/",
    phone: "+31623459958"
  },
  {
    latitude: 51.243912864878297,
    longitude: 3.345056875280988,
    name: "Apotheek Rogge",
    address: "Moerkerkebrug 1, 8340 Damme",
    website: "https://apotheekrogge.be/",
    phone: "050500261"
  },
  {
    latitude: 50.867774649463257,
    longitude: 3.404916638544921,
    name: "Apotheek Verhofstede",
    address: "Deerlijkseweg 111, 8790 Waregem",
    website: "http://www.apotheekverhofstede.be/",
    phone: "056602929"
  },
  {
    latitude: 51.14198492530074,
    longitude: 4.295978011631427,
    name: "Apotheek La Pharma",
    address: "Rupelmondestraat 100a, 9150 Kruibeke",
    website: "http://www.lapharma.be/",
    phone: "037742304"
  },
  {
    latitude: 51.135224596926037,
    longitude: 4.448070605879985,
    name: "Club Geluk",
    address: "Gemeenteplein 19, 2550 Kontich",
    website: "https://www.club-geluk.be",
    phone: "0467 01 57 58"
  },
  {
    latitude: 50.777752620212759,
    longitude: 4.895423821225202,
    name: "Apotheek Julie Maes",
    address: "Tiensestraat 48, 3320 Hoegaarden",
    website: "https://www.apotheekmaes.be",
    phone: "016 76 61 17"
  },
  {
    latitude: 50.867415492559367,
    longitude: 4.639829535033884,
    name: "Apotheek Kinget Bertem Zorgpunt",
    address: "Tervuursesteenweg 69, 3060 Bertem",
    website: "https://www.apotheek-kinget.be",
    phone: "016 49 01 49"
  },
  {
    latitude: 51.21693710173691,
    longitude: 4.395004269311714,
    name: "Supergoods Antwerpen",
    address: "Kloosterstraat 38, 2000 Antwerpen",
    website: "https://www.supergoods.be",
    phone: "0476 90 37 07"
  },
  {
    latitude: 51.022963399711344,
    longitude: 4.481959492064858,
    name: "Supergoods Mechelen",
    address: "Onze-Lieve-Vrouwestraat 116, 2800 Mechelen",
    website: "https://www.supergoods.be",
    phone: "0486 34 12 55"
  },
  {
    latitude: 50.858917152195524,
    longitude: 3.607384758570705,
    name: "Anemoon Conceptstore & Koffiebar",
    address: "Nederstraat 24, 9700 Oudenaarde",
    website: "https://www.anemoon9700.be",
    phone: "0471 62 13 64"
  },
  {
    latitude: 51.152553440259794,
    longitude: 3.526961661376573,
    name: "Salon 24",
    address: "Leendreef 24, 9931 Lievegem",
    website: "https://www.salon24.online",
    phone: "0474 76 80 64"
  },
  {
    latitude: 50.933735654702573,
    longitude: 5.570252561376573,
    name: "Apotheek Thoen Klaartje",
    address: "Hoogstraat 25, 3690 Zutendaal",
    website: "https://apotheekpanorama.be",
    phone: "089 61 16 74"
  },
  {
    latitude: 50.994846264646895,
    longitude: 4.708677430688286,
    name: "Tremelose Apotheek Panorama",
    address: "Baalsebaan 36, 3120 Tremelo",
    website: "https://apotheekpanorama.be",
    phone: "016 53 00 31"
  },
  {
    latitude: 50.995576083027665,
    longitude: 4.736641630688285,
    name: "Kruispuntapotheek Panorama",
    address: "Baalsebaan 220, 3128 Tremelo",
    website: "https://apotheekpanorama.be",
    phone: "016 53 53 01"
  },
  {
    latitude: 50.750549581265055,
    longitude: 5.081067115344142,
    name: "Apotheek Panorama Vanbrabant",
    address: "Bondgenotenlaan 2, 3400 Landen",
    website: "https://apotheekpanorama.be",
    phone: "011 88 38 51"
  },
  {
    latitude: 50.987554360437613,
    longitude: 5.193577761376572,
    name: "Apotheek Panorama Lummen",
    address: "Dorpsstraat 18, 3560 Lummen",
    website: "https://apotheekpanorama.be",
    phone: "013 53 11 53"
  },
  {
    latitude: 51.164739365354016,
    longitude: 4.981507268259432,
    name: "Apotheek Panorama Thiels",
    address: "Elsum 58, 2440 Geel",
    website: "https://apotheekpanorama.be",
    phone: "014 58 85 75"
  },
  {
    latitude: 51.013900191181165,
    longitude: 5.231909029109862,
    name: "Apotheek Panorama Genenbos",
    address: "Genenbosstraat 127, 3560 Lummen",
    website: "https://apotheekpanorama.be",
    phone: "011 42 16 85"
  },
  {
    latitude: 50.999664421176966,
    longitude: 4.75327572117472,
    name: "Apotheek Panorama Baal (Dehing)",
    address: "Pastoriestraat 60, 3128 Tremelo",
    website: "https://apotheekpanorama.be",
    phone: "016 53 00 42"
  },
  {
    latitude: 50.939003241318339,
    longitude: 4.040563130685692,
    name: "Schoonheidssalon Linia",
    address: "Rozemarijnstraat 5, 9300 Aalst",
    website: "https://schoonheidssalon-linia.salonized.com",
    phone: "0479 59 40 24"
  },
  {
    latitude: 51.202449868437384,
    longitude: 3.238256946028538,
    name: "Apotheek Cornille",
    address: "Generaal Lemanlaan 78, 8310 Brugge",
    website: "http://apotheekcornille.be",
    phone: "050 37 23 03"
  },
  {
    latitude: 50.805914931888474,
    longitude: 4.153123845968663,
    name: "De Heppie Store",
    address: "Kroonstraat 30, 1750 Lennik",
    website: "https://www.de-heppie-store.be",
    phone: "02 453 12 07"
  },
  {
    latitude: 50.852381467963404,
    longitude: 4.345916769314307,
    name: "Urban therapy shop Zaventem airport",
    address: "Leopoldlaan, 1930 Zaventem",
    website: "https://www.urbantherapy.store",
    phone: "02 319 44 42"
  },
  {
    latitude: 51.124178090653196,
    longitude: 4.197490184657155,
    name: "Schoonheidsinstituut Looxs",
    address: "Sint-Amelbergalaan 60, 9140 Temse",
    website: "https://www.looxs.be",
    phone: "0474 88 05 40"
  },
  {
    latitude: 51.13908289577067,
    longitude: 3.847162530685694,
    name: "'t Jongehof",
    address: "Het Jongestraat 9, 9080 Lochristi",
    website: "https://tjongehof.be",
    phone: "0499 12 34 22"
  },
  {
    latitude: 51.015485582298723,
    longitude: 4.957539505770926,
    name: "Novilla Beauty HAAR en Beauty cafe",
    address: "Plaats-Vondel 1, 3272 Scherpenheuvel-Zichem",
    website: "https://www.haarenbeautycafe.be",
    phone: "013 77 74 65"
  },
  {
    latitude: 51.320493665713535,
    longitude: 4.953295976714231,
    name: "ToBe centrum voor gezondheid, groei en ontwikkeling",
    address: "Hendrik Consciencestraat 20, 2300 Turnhout",
    website: "https://www.tobe-kempen.be",
    phone: "014 39 44 22"
  },
  {
    latitude: 51.027235660218331,
    longitude: 3.140967011639249,
    name: "Lucy's Living",
    address: "Neerstraat 12, 8810 Lichtervelde",
    website: "https://lucysliving.be",
    phone: "0485 38 87 74"
  },
  {
    latitude: 51.05566049460915,
    longitude: 4.625882179762337,
    name: "Parfum & More",
    address: "Gravenhoek 25, 2580 Putte",
    website: "https://parfumenmore.be/Webshop",
    phone: "0472121772"
  },
  {
    latitude: 51.067200651543729,
    longitude: 5.087685660285223,
    name: "Apotheek Jans",
    address: "Diesterstraat 1, 3980 Tessenderlo",
    website: "https://apotheek-jans.be",
    phone: "013 66 24 59"
  },
  {
    latitude: 51.387435584261326,
    longitude: 4.534996707943141,
    name: "Eco-Brands",
    address: "Morellaan 30, 2990 Wuustwezel",
    website: "https://eco-brands.eu",
    phone: "0494 49 65 51"
  },
  {
    latitude: 51.02947139119474,
    longitude: 4.480154085264754,
    name: "Atelier B\u00e9B\u00e9",
    address: "Frederik de Merodestraat 15, 2800 Mechelen",
    website: "https://www.atelierbebe.be/",
    phone: "015209676"
  },
  {
    latitude: 51.103884420776922,
    longitude: 4.918393416273098,
    name: "Schoonheidsinstituut Calmant\u00e9",
    address: "Voorteinde 6, 2260 Westerlo",
    website: "http://www.calmante.be/",
    phone: "0496181848"
  },
  {
    latitude: 51.024112175511334,
    longitude: 4.693919715300344,
    name: "Laperla Nella Schoonheidsinstituut",
    address: "Leuvensebaan 43, 2223 Heist-op-den-Berg",
    website: "https://www.laperlanella.be/",
    phone: "0473517114"
  },
  {
    latitude: 50.892976413602291,
    longitude: 5.528744776650324,
    name: "Nail & Beautycenter Anke",
    address: "Oude Beekstraat 23, 3740 Bilzen",
    website: "http://www.nailandbeautycenteranke.be/",
    phone: "0497128592"
  },
  {
    latitude: 50.885286023133808,
    longitude: 4.701183676668402,
    name: "Sant\u00e9 Magic",
    address: "Vaartstraat 78, 3000 Leuven",
    website: "http://www.santemagic.be/",
    phone: "0469164858"
  },
  {
    latitude: 50.758673324215053,
    longitude: 3.853340499925118,
    name: "Estheti'K",
    address: "Groteweg 392, 9500 Geraardsbergen",
    website: "http://www.esthetik.be/",
    phone: "0485767188"
  },
  {
    latitude: 50.964619492938652,
    longitude: 3.120846453917364,
    name: "Castard",
    address: "Brugsesteenweg 292, 8800 Roeselare",
    website: "http://www.castard.be/",
    phone: "051322349"
  },
  {
    latitude: 51.097596216170736,
    longitude: 3.208528273011067,
    name: "Instituut Cleopatra",
    address: "Hillestraat 1/A, 8020 Oostkamp",
    website: "http://www.instituutcleopatra.be/",
    phone: "0488464606"
  },
  {
    latitude: 51.152649892980492,
    longitude: 3.234235296306197,
    name: "K-Deetje",
    address: "Kortrijksestraat 58, 8020 Oostkamp",
    website: "",
    phone: "0471 67 78 92"
  },
  {
    latitude: 51.272746123032462,
    longitude: 4.701789765604813,
    name: "New Life",
    address: "Steynhoefsedreef 32, 2970 Schilde",
    website: "",
    phone: "0486 37 98 37"
  },
  {
    latitude: 50.888320534046088,
    longitude: 4.701789765604813,
    name: "Noordoever",
    address: "Vaartkom 17A, 3000 Leuven",
    website: "https://www.noordoever.be/",
    phone: "016 29 04 70"
  },
  {
    latitude: 51.177143274652522,
    longitude: 4.836773746025339,
    name: "Cute'nd Kind",
    address: "Grote Markt 20, 2200 Herentals",
    website: "https://cutendkind.be/",
    phone: "0468 13 64 14"
  },
  {
    latitude: 51.134305306483597,
    longitude: 4.567093915341028,
    name: "JESS FASHIONSTORE",
    address: "Antwerpsestraat 79, 2500 Lier",
    website: "http://www.jessfashionstore.be/",
    phone: "032948049"
  },
  {
    latitude: 51.210515813631098,
    longitude: 5.114839338635094,
    name: "The Face Bar",
    address: "Turnhoutsebaan 301, 2400 Mol",
    website: "https://www.thefacebar.be/",
    phone: "0498568297"
  },
  {
    latitude: 51.26605669205172,
    longitude: 4.636958815341227,
    name: "Mini Butik",
    address: "Handelslei 102, 2980 Zoersel",
    website: "",
    phone: "0479 58 78 66"
  },
  {
    latitude: 50.764609832646343,
    longitude: 3.459843526976537,
    name: "A Fleur de Peau",
    address: "Rejet de Rhosnes 5A, 7760 Escanaffles",
    website: "https://a-fleurdepeau.jimdo.com/",
    phone: "0486 78 83 93"
  },
  {
    latitude: 51.232669260658298,
    longitude: 4.424198394917493,
    name: "By mags",
    address: "Damplein 4, 2060 Antwerpen",
    website: "https://bymags.be/",
    phone: "0492 17 22 71"
  },
  {
    latitude: 51.814287587979358,
    longitude: 4.667042038635094,
    name: "Amiri Beauty Boutique",
    address: "Korte Breestraat 3, 3311 ND Dordrecht, Nederland",
    website: "http://www.amiribeautyboutique.nl/",
    phone: "+31652199823"
  },
  {
    latitude: 51.113349111540799,
    longitude: 5.606439956086968,
    name: "Apotheek Thomas Paesen",
    address: "Weg naar Opoeteren 162, 3660 Oudsbergen",
    website: "http://www.apotheekthomaspaesen.be/",
    phone: "089855313"
  },
  {
    latitude: 51.080689995411433,
    longitude: 5.652656488421284,
    name: "Apotheek Paesen",
    address: "Neeroeterenstraat 8, 3680 Maaseik",
    website: "",
    phone: "089863092"
  },
  {
    latitude: 50.984052976876505,
    longitude: 5.052912452065597,
    name: "Apotheek Diest - Sofie Adams",
    address: "Hasseltsestraat 2, 3290 Diest",
    website: "https://apotheekdiest.be/",
    phone: "013311382"
  },
  {
    latitude: 51.226943503372794,
    longitude: 2.910099246028858,
    name: "Modest Oostende",
    address: "Torhoutsesteenweg 30, 8400 Oostende",
    website: "https://www.bemodest.be/shop/",
    phone: "059268745"
  },
  {
    latitude: 51.201041671953028,
    longitude: 3.247739046030595,
    name: "Lots of Lili",
    address: "Astridlaan 5, 8310 Brugge",
    website: "http://www.lotsoflili.be/",
    phone: "0473474245"
  },
  {
    latitude: 50.963861073775902,
    longitude: 5.468026022748253,
    name: "Blabloom",
    address: "Hasseltweg 78, 3600 Genk",
    website: "http://www.blabloom.com/",
    phone: "089717477"
  },
  {
    latitude: 52.297773661841525,
    longitude: 4.902664915343531,
    name: "StudioBELS",
    address: "Dorpsstraat 30, 1191 BK Ouderkerk aan de Amstel, Nederland",
    website: "https://studiobels.nl/",
    phone: "+31615315458"
  },
  {
    latitude: 51.068563286687841,
    longitude: 5.0888216,
    name: "LEF",
    address: "Markt 19, 3980 Tessenderlo",
    website: "http://www.lef-tessenderlo.be/",
    phone: "0496807978"
  },
  {
    latitude: 50.996544213073712,
    longitude: 4.267079084656468,
    name: "SLOW Concepstore & Workshops",
    address: "Brouwerijstraat 2/1, 1840 Londerzeel",
    website: "http://www.slowshopsteenhuffel.be/",
    phone: "052305623"
  },
  {
    latitude: 52.21000813469167,
    longitude: 5.297952676717657,
    name: "J&W Sustainable Products",
    address: "Faas Eliaslaan 39, 3742 AS Baarn, Nederland",
    website: "https://mysustainableproducts.nl/",
    phone: ""
  },
  {
    latitude: 50.93672763407541,
    longitude: 4.040583915343531,
    name: "Philimonius",
    address: "Louis D'Haeseleerstraat 8, 9300 Aalst",
    website: "http://www.philimonius.be/",
    phone: "0488201358"
  },
  {
    latitude: 54.323142162636231,
    longitude: 10.138607899999998,
    name: "derHeimathafen",
    address: "Holstenstra\u00dfe 2-12, 24103 Kiel, Duitsland",
    website: "https://derheimathafen.net/",
    phone: "+494313644936"
  },
  {
    latitude: 50.846167230496143,
    longitude: 3.106864842328235,
    name: "Feels",
    address: "Millesteenstraat 67, 8890 Moorslede",
    website: "https://feels-store.be",
    phone: ""
  },
  {
    latitude: 38.712318345788468,
    longitude: -9.41255761534353,
    name: "EcoTiny",
    address: "Av. Dr. Morais Sarmento 171, 2755-285 Alcabideche, Portugal",
    website: "http://eco-tiny.com/",
    phone: "+351936229854"
  },
  {
    latitude: 51.171579537623693,
    longitude: 4.394416284656469,
    name: "Instituut Wenless",
    address: "Jules Moretuslei 185, 2610 Wilrijk",
    website: "http://www.instituutwenless.be/",
    phone: "038303766"
  },
  {
    latitude: 51.13240851609968,
    longitude: 2.751796471145888,
    name: "Nomad",
    address: "Langestraat 97, 8620 Nieuwpoort",
    website: "http://www.nomadlifestyleshop.be/",
    phone: "058598010"
  },
  {
    latitude: 50.947076688362849,
    longitude: 3.123382073142273,
    name: "Vida design",
    address: "De Munt 2, en 7, 8800 Roeselaren",
    website: "https://www.vida-design.be/",
    phone: "051801191"
  },
  {
    latitude: 51.110702278380344,
    longitude: 3.967957827121293,
    name: "Noppe Slaapcultuur",
    address: "Gentse Steenweg 9, 9160 Lokeren",
    website: "https://noppeslaapcultuur.be/",
    phone: "093481972"
  },
  {
    latitude: 51.027837477061375,
    longitude: 4.100696316517033,
    name: "Mon Ciel",
    address: "Brusselsestraat 71, 9200 Dendermonde",
    website: "http://www.monciel.be/",
    phone: "052211348"
  },
  {
    latitude: 51.324630411287906,
    longitude: 5.074124169317202,
    name: "Bjojo",
    address: "Heirbaan 2, 2370 Arendonk",
    website: "http://www.bjojo.be/",
    phone: "0497846914"
  },
  {
    latitude: 51.123723958288522,
    longitude: 4.474780215341398,
    name: "Little Lux Hairsalon",
    address: "Witte-Stedeweg 5, 2550 Kontich",
    website: "https://www.facebook.com/profile.php?id=100063736413400&ref=nearby_places",
    phone: "0494401544"
  },
  {
    latitude: 51.038493087962792,
    longitude: 3.708245843928874,
    name: "Vertel",
    address: "Aaigemstraat 41, 9000 Gent",
    website: "https://vertelstore.be",
    phone: ""
  },
  {
    latitude: 51.096817176680254,
    longitude: 3.832052546023529,
    name: "Apotheek Dierickx",
    address: "Dorp-West 30, 9080 Lochristi",
    website: "https://www.facebook.com/ApotheekDieickx",
    phone: "093555360"
  },
  {
    latitude: 50.455453886250979,
    longitude: 3.953928526985531,
    name: "MAERI",
    address: "Rue du Miroir 23, 7000 Mons",
    website: "http://maeri.be/",
    phone: "0474706188"
  },
  {
    latitude: 50.952337021442247,
    longitude: -4.143534657671989,
    name: "Torrington Refill Store",
    address: "11 South St, Great Torrington, Torrington EX38 8AA, Verenigd Koninkrijk",
    website: "https://www.facebook.com/torringtonrefillstore/",
    phone: "+441805625219"
  },
  {
    latitude: 43.356952926416298,
    longitude: 1.234690844178602,
    name: "Mellemel Boutik",
    address: "17 rue raymond alibert 31410 Longages, France ",
    website: "https://www.mellemelboutik.fr",
    phone: "0769371939"
  },
  {
    latitude: 48.752371754980665,
    longitude: 8.549454615340272,
    name: "sell4u",
    address: "Wilhelmstra\u00dfe 27, 75323 Bad Wildbad, Duitsland",
    website: "http://www.facebook.com/sell4u.shop",
    phone: "+4970813092100"
  },
  {
    latitude: 48.435483694546093,
    longitude: 12.957864169319459,
    name: "Seller Point UG",
    address: "Kapellenweg 9, 84347 Pfarrkirchen, Duitsland",
    website: "",
    phone: "+49 8561 9890859"
  },
  {
    latitude: 46.002377519872759,
    longitude: 5.028269371164932,
    name: "Peau de p\u00eache shop",
    address: "36 Rue du Moyen \u00c2ge, 01330 Villars-les-Dombes, Frankrijk",
    website: "https://www.peaudepecheshop.com/shop",
    phone: "+33658140976"
  },
  {
    latitude: 42.148905819712347,
    longitude: 2.577452657670136,
    name: "Amapola Vegan Shop",
    address: "Passatge la Quintana, 1, 17811 Santa Pau, Girona, Spanje",
    website: "https://amapolaveganshop.com",
    phone: "+34678718869"
  },
  {
    latitude: 50.752176200930379,
    longitude: 3.658498640186527,
    name: "House Of Music & Accessories",
    address: "Schoonboeke 10, 9600 Ronse",
    website: "http://www.homa.be/",
    phone: "093808180"
  },
  {
    latitude: 49.619497164738881,
    longitude: 3.225475084659729,
    name: "Merveilles du Monde Bijoux",
    address: "Rue Paul Doumer, 02300 Chauny, Frankrijk",
    website: "https://www.merveillesdumonde.fr/",
    phone: "+33360429382"
  },
  {
    latitude: 51.440863856990774,
    longitude: 14.246256086499386,
    name: "Waya",
    address: "Spremberger Str. 37, 02977 Hoyerswerda, Duitsland",
    website: "",
    phone: "+491629112151 "
  },
  {
    latitude: 51.589356113948227,
    longitude: 4.309302199994388,
    name: "Natuurlijk Plasticvrij",
    address: "Prins Reinierstraat 8, 4651 RZ Steenbergen, Nederland",
    website: "https://natuurlijkplasticvrij.nl",
    phone: "+31850602833"
  },
  {
    latitude: 51.190580396091974,
    longitude: 3.279352371154705,
    name: "EC Bruges",
    address: "Astridlaan 490, 8310 Brugge",
    website: "",
    phone: "+32496045108"
  },
  {
    latitude: 49.724996854191893,
    longitude: 10.008355971156892,
    name: "Beate Hansel",
    address: "Lerchenberg 1, 97246 Eibelstadt, Duitsland",
    website: "",
    phone: "+4917623705388"
  },
  {
    latitude: 57.637218200628851,
    longitude: 18.294673549065667,
    name: "Bees and Things",
    address: "Adelsgatan 32, 621 57 Visby, Zweden",
    website: "",
    phone: "+46730211200 "
  },
  {
    latitude: 51.064988571402964,
    longitude: 3.637190069281729,
    name: "Apotheek Vlaeminck",
    address: "Beekstraat 145, 9031 Gent",
    website: "http://www.apotheek-vlaeminck.be/",
    phone: "092269540"
  },
  {
    latitude: 51.986371434992911,
    longitude: 4.376386661359475,
    name: "Lockoloop",
    address: "Rotterdamseweg 396, 2629 HH Delft, Nederland",
    website: "https://lockoloop.nl/",
    phone: "+31649416414"
  },
  {
    latitude: 50.726372645089135,
    longitude: 3.646349371156495,
    name: "Blijzonder",
    address: "Aulnoit 75, 7890 Ellezelles",
    website: "https://www.blijzonder.be/nl/",
    phone: "+32498281355"
  },
  {
    latitude: 51.457927783312201,
    longitude: 19.664747099989825,
    name: "Better Planet Ewa Samek",
    address: "Wola Bykowska 31, 97-306 Wola Bykowska, Polen",
    website: "https://pandawanda.pl",
    phone: "+48666715713"
  },
  {
    latitude: 50.974932399504226,
    longitude: 5.065579299993497,
    name: "Moana babyspa & wellness",
    address: "Halensebaan 16, 3290 Diest",
    website: "https://moanababyspa.be",
    phone: "+32498766364"
  },
  {
    latitude: 50.839037940593656,
    longitude: 4.348779820403188,
    name: "Urban Therapy",
    address: "Rue Blaes 96B, 1000 Brussels",
    website: "https://www.urbantherapy.store/home",
    phone: "02/319.44.42"
  },
  {
    latitude: 50.852306273893284,
    longitude: 4.346068657665067,
    name: "Urban Therapy",
    address: "Rue de Flandre 84, 1000 Brussels",
    website: "https://www.urbantherapy.store/home",
    phone: "02/319.44.42"
  },
  {
    latitude: 52.336760166527313,
    longitude: 4.929521384987519,
    name: "Plastic Free Amsterdam",
    address: "H.J.E. Wenckebachweg 144, 1114 AD Amsterdam, Nederland",
    website: "https://www.plasticfreeamsterdam.com",
    phone: ""
  },
  {
    latitude: 51.778373106552571,
    longitude: 5.108541369439848,
    name: "'t Schrijvertje",
    address: "Witboomstraat 27, 4264 RT Veen, Nederland",
    website: "https://www.schrijvertje.com/",
    phone: "+31416697330"
  },
  {
    latitude: 51.284687704174807,
    longitude: 4.430110899944552,
    name: "Potteke",
    address: "Bremboslei 66, 2180 Ekeren",
    website: "https://potteke.be",
    phone: "+32486463428"
  },
  {
    latitude: 51.072496860353091,
    longitude: 2.664052067260853,
    name: "Palu Palu",
    address: "Grote Markt 22, 8630 Veurne",
    website: "https://www.palupalu.be/nl/home",
    phone: "+32476445538"
  },
  {
    latitude: 43.327793259632266,
    longitude: 16.448344501275088,
    name: "Fieldgood",
    address: "Sridnja Kala, 21405, Milna, Kroati\u00eb",
    website: "",
    phone: "+385911238575"
  },
  {
    latitude: 51.126741902237143,
    longitude: 5.660196384658695,
    name: "Eco on my Mind",
    address: "Solterweg 4, 3960 Bree",
    website: "https://www.eco-onmymind.be/",
    phone: "0495/87 27 31"
  },
  {
    latitude: 52.073650505922487,
    longitude: 4.332647315341304,
    name: "The Bo Collective",
    address: "Binckhorstlaan 36 - C111, 2516 BE, Den Haag, Nederland",
    website: "https://thebocollective.nl/",
    phone: "+31683658486"
  },
  {
    latitude: 43.282814717803547,
    longitude: 5.384457128835325,
    name: "Henn\u00e9 Beaut\u00e9 au Naturel",
    address: "59 Rue Saint Sebastien 13006 Marseille",
    website: "https://www.facebook.com/groups/christel0311/",
    phone: ""
  },
  {
    latitude: 51.1190001256264,
    longitude: 4.018828684658696,
    name: "Iduna",
    address: "Antwerpse Steenweg 82, 9160 Lokeren",
    website: "https://idunagezondgenieten.be/",
    phone: "0494/27 37 74"
  },
  {
    latitude: 51.201209983540316,
    longitude: 4.39561894417663,
    name: "Hormao",
    address: "Jonghelinckstraat 13, 2018 Antwerpen",
    website: "https://www.hormao.be/",
    phone: ""
  },
  {
    latitude: 51.132490201212875,
    longitude: 2.670722538071735,
    name: "Babette",
    address: "Pylyserlaan 47, 8670 Koksijde",
    website: "https://www.babetteconcept.be/nl_BE",
    phone: "+32 460 97 07 42"
  },
  {
    latitude: 52.385421637219252,
    longitude: 6.041452357671384,
    name: "Cozy by B",
    address: "Bonenburgerlaan 26, 8181HE Heerde",
    website: "https://www.cozybyb.nl/",
    phone: ""
  },
  {
    latitude: 45.508155177224296,
    longitude: 10.308814444176631,
    name: "Stellina",
    address: "Via Brodolini 16, Rezzato 25086 BS Itali\u00eb",
    website: "https://stellina.shop/",
    phone: ""
  },
  {
    latitude: 50.855827348305446,
    longitude: 2.72550405396939,
    name: "Odevie Poperinge",
    address: "Grote Markt 18, 8970 Poperinge",
    website: "https://www.odeviepoperinge.be/",
    phone: "057 37 77 40"
  },
  {
    latitude: 50.868005350422742,
    longitude: 5.425348086505978,
    name: "Earthly",
    address: "Fonteinstraat 50, 3721 Vliermaalroot Belgi\u00eb",
    website: "https://www.earthlyweb.be/",
    phone: ""
  },
  {
    latitude: 48.009113868283436,
    longitude: -0.397209215341304,
    name: "Mon passage au naturel",
    address: "10 rue du haut bourg, 53270 Saint-Pierre-sur-Erve, Frankrijk",
    website: "https://www.monpassageaunaturel.fr/",
    phone: "+33 6 21 78 25 23"
  },
  {
    latitude: 43.830859772460812,
    longitude: 4.33145824417663,
    name: "Boutique Rouqaiah",
    address: "4 rue Jacques monod, 30900 N\u00eemes, Frankrijk",
    website: "https://www.boutiquerouqaiah.fr/",
    phone: "06.01.63.88.24"
  },
  {
    latitude: 52.044638188404903,
    longitude: 5.667756861928265,
    name: "Zonnestudio Ede",
    address: "Telefoonweg, 86, 6713AL Ede, Nederland",
    website: "https://www.zonnestudioede.nl/",
    phone: "0318-652840"
  },
  {
    latitude: 51.009397653247781,
    longitude: 4.868156623279499,
    name: "Silo",
    address: "Oude Mechelsebaan 417/Bus 2, 3201 Aarschot",
    website: "https://www.silo.eco/",
    phone: "0496 87 41 91"
  },
  {
    latitude: 52.496465559815398,
    longitude: 13.321289492610873,
    name: "FAIR unverpackt",
    address: "D\u00fcsseldorfer Str.12, 10719 Berlin, Duitsland",
    website: "https://www.fair-unverpackt.de/",
    phone: "+49 30 55477777"
  },
  {
    latitude: 40.629643714223938,
    longitude: -8.608568644542533,
    name: "Natural Choices \u2013 Eco & Organic",
    address: "Rua M\u00e1rio Duarte N45 Santa Joana, Solposto, 3810-027 Aveiro, Portugal",
    website: "https://naturalchoices.pt/",
    phone: ""
  },
  {
    latitude: 51.299592189016451,
    longitude: 4.448297038634785,
    name: "Ecossentials",
    address: "Charlottalei 2, 2930 Brasschaat",
    website: "https://ecossentials.eu/",
    phone: ""
  },
  {
    latitude: 50.885817574542081,
    longitude: 3.359586626985851,
    name: "Dagelijks Duurzaam",
    address: " Astridlaan 36, 8792 Waregem",
    website: "https://dagelijksduurzaam.be/",
    phone: "+32 498 50 34 27"
  },
  {
    latitude: 50.790690233767897,
    longitude: 4.83428285396939,
    name: "Apotheek De Vriendt",
    address: "Kerselaarstraat 16, 3320 Hoegaarden",
    website: "https://apotheekmeldert.be/",
    phone: " 016 89 69 79"
  },
  {
    latitude: 50.859811494269017,
    longitude: 3.122338638625854,
    name: "Apotheek Tack",
    address: "Papestraat 2, 8880 Ledegem",
    website: "https://www.apotheektack.be/",
    phone: "056 50 00 05"
  },
  {
    latitude: 43.5517170769321,
    longitude: 7.03121977670652,
    name: "Accessories Cannes",
    address: "10 avenue mar\u00e9chal juin, 06400 Cannes, Frankrijk",
    website: "https://www.accessoriescannes.com/",
    phone: ""
  },
  {
    latitude: 44.839344417202703,
    longitude: -0.585029676706519,
    name: "Happy Store by TLOF",
    address: "57 Rue du Ch\u00e2teau d'Eau - Centre Commercial M\u00e9riadeck - 1er \u00e9tage, 33000 Bordeaux, Frankrijk",
    website: "https://www.facebook.com/HappyStorebyTheLibraryofFragrance/",
    phone: "+33 5 56 42 69 62"
  },
  {
    latitude: 50.646235687798999,
    longitude: 5.58822707670652,
    name: "Oufticoop SC",
    address: "Rue Curtius 10, 4020 Li\u00e8ge",
    website: "https://www.oufticoop.be/",
    phone: "04/254.39.06"
  },
  {
    latitude: 50.313555011167878,
    longitude: 4.54562542273043,
    name: "Mystic Green",
    address: "Rue Lauricot 16, 5621 Florennes",
    website: "https://www.facebook.com/Dioncreation/?ref=page_internal",
    phone: "0479 57 61 33"
  },
  {
    latitude: 51.070631698049141,
    longitude: 3.751009446023912,
    name: "LM Zorgshop",
    address: "Sint-Bernadettestraat 73, 9000 Gent",
    website: "https://www.lm-ml.be/nl/lm-oost-vlaanderen",
    phone: "09 223 19 76"
  },
  {
    latitude: 51.062934333723675,
    longitude: 4.198785276720502,
    name: "Kapsalon asselberghs bvba",
    address: "Burgemeester Karel Van Doorslaerlaan 67, 2880 Mariekerke",
    website: "https://www.haarkliniekasselberghs.be/",
    phone: "052 33 27 26"
  },
  {
    latitude: 52.285833729493845,
    longitude: -1.53323774232795,
    name: "IKIGAI",
    address: "14 Spencer Street, Leamington Spa, CV31 3NF",
    website: "https://www.ikigailiving.co.uk/",
    phone: ""
  },
  {
    latitude: 50.890668582230823,
    longitude: 3.4382052,
    name: "Apotheek Vanderhaegen",
    address: "Churchilllaan 15, 8790 Waregem",
    website: "https://www.apotheekvanderhaegen.be/",
    phone: "+32(0)56 60 35 88"
  },
  {
    latitude: 50.872406973233822,
    longitude: 4.721375315344099,
    name: "Apotheek Biloba",
    address: "Tiensesteenweg 154, 3001 Heverlee",
    website: "https://www.apotheekbiloba.be/",
    phone: "016 25 96 11"
  },
  {
    latitude: 50.884450272513256,
    longitude: 4.721932661376401,
    name: "Apotheek Biloba",
    address: "Diestsesteenweg 143, 3010 Kessel-Lo",
    website: "https://www.apotheekbiloba.be/",
    phone: "016 25 97 91"
  },
  {
    latitude: 51.132448909760782,
    longitude: 5.454354515341303,
    name: "Ammi conceptstore",
    address: "Markt 24 bus 1, 3990 Peer",
    website: "https://www.ammiconceptstore.be/",
    phone: ""
  },
  {
    latitude: 51.097202576931508,
    longitude: 4.232978553976088,
    name: "Cosas",
    address: "Boomstraat 77, 2880 Bornem",
    website: "https://www.cosas.be/",
    phone: "+32 475 44 95 08"
  },
  {
    latitude: 56.650939980217196,
    longitude: 8.526593107389129,
    name: "Hyphesten",
    address: "Jernbanegade 10, 7790 Thyholm, Denemarken",
    website: "https://hyphesten.dk/",
    phone: "+45 61 26 62 04"
  },
  {
    latitude: 40.41273622006193,
    longitude: -3.707429930682607,
    name: "Ecomania",
    address: "C. de los Estudios, 10, 28012 Madrid, Spanje",
    website: "https://ecomaniaonline.com/",
    phone: "684033462"
  },
  {
    latitude: 51.033622826418899,
    longitude: 4.079567315341304,
    name: "Sweet Magnolia",
    address: "Pieter Goruslaan 8, 9200 Dendermonde",
    website: "https://www.sweetmagnolia.be/",
    phone: "0476/93.73.76"
  },
  {
    latitude: 51.319681065731224,
    longitude: 4.979111707952177,
    name: "Omloop",
    address: "Kerkstraat 1/bus 1, 2360 Oud-Turnhout",
    website: "https://www.omloop.eu/",
    phone: "+32494 93 81 81"
  },
  {
    latitude: 50.907092843560903,
    longitude: 4.107634946023913,
    name: "A POINT EVENTS",
    address: "Buikouterbaan 2, 1790 Affligem",
    website: "https://www.apointevents.be/",
    phone: "+32 476866122"
  },
  {
    latitude: 51.31552369059844,
    longitude: 3.127621584658696,
    name: "V\u00e0nn",
    address: "Bakkersstraat 35, 8370 Blankenberge",
    website: "https://www.vann-pure.be/",
    phone: "0477 27 45 32"
  },
  {
    latitude: 50.850779081061162,
    longitude: 3.341123828835326,
    name: "Nyima Esthetiek",
    address: "Marquettestraat 18, 8540 Deerlijk",
    website: "https://www.nyimaesthetiek.com/",
    phone: "0473 60 14 51"
  },
  {
    latitude: 50.871836995640557,
    longitude: 4.083454577910595,
    name: "esthetiek margot",
    address: "Stationsstraat 13, 1770 Liedekerke",
    website: "https://www.esthetiek-margot.be/?gad_source=1&gad_campaignid=19581352998&gbraid=0AAAAAD2cpL0Ni9fFIe4X4JgDQtwy9ML2F&gclid=CjwKCAjw7MLDBhAuEiwAIeXGIaWyZmDblpxHIE6ihIbuyxS6k1vFd20xmaMWpLpY9cBpI3QzvRtIZBoCjUUQAvD_BwE",
    phone: "053/39.79.87 "
  },
  {
    latitude: 50.771064640041523,
    longitude: 3.875863250925167,
    name: "Ernel",
    address: "Lessensestraat 28 9500, Hulst",
    website: "https://www.ernel.be/",
    phone: "054 411863"
  },
  {
    latitude: 50.96967493159471,
    longitude: 5.360799030682608,
    name: "Mio en Moi",
    address: "Luchtvaartstraat 7, 3500 Hasselt",
    website: "https://www.mioenmoi.be/",
    phone: "+32 479 04 37 83"
  },
  {
    latitude: 50.781396701507639,
    longitude: 5.464976184657328,
    name: "Esthetiek Anne",
    address: "Kloosterstraat 1, 3700 Tongeren",
    website: "https://esthetiek-anne.be/",
    phone: "0483 20 80 57"
  },
  {
    latitude: 50.924581775694193,
    longitude: 5.686302392610874,
    name: "Salon MIC",
    address: "Steenweg 132, 3621 Lanaken",
    website: "https://www.salon-mic.be/",
    phone: "089 21 88 21"
  },
  {
    latitude: 51.023019646400506,
    longitude: 4.293978069317393,
    name: "Naturelle",
    address: "Topmolen 11/N259, 1840 Londerzeel",
    website: "https://naturelle-londerzeel.be/",
    phone: "0486/53.68.04"
  },
  {
    latitude: 50.93129399460399,
    longitude: 4.080581486356321,
    name: "Boetiek Puur",
    address: "Linthout 30, 9300 Aalst",
    website: "https://boetiekpuur.be/",
    phone: "0472/95.83.82"
  },
  {
    latitude: 51.393237362446577,
    longitude: 4.474785030682607,
    name: "Apotheek Hendrickx",
    address: "Kapellensteenweg 23, 2920 Kalmthout",
    website: "https://www.apotheekhendrickx.be/",
    phone: "+32\u202f3\u202f666\u202f86\u202f90"
  },
  {
    latitude: 50.932990786107673,
    longitude: 5.335225315341304,
    name: "Paplou",
    address: "Dorpsstraat 37b, 3500 Hasselt",
    website: "https://www.paplou.be/",
    phone: "011 75 06 41"
  },
  {
    latitude: 51.067027779955005,
    longitude: 3.732768226996697,
    name: "Apotheek Dok Noord",
    address: "Dok-Noord 7/Bus 8, 9000 Gent",
    website: "https://www.apotheekdoknoord.be/",
    phone: "09/324 00 03"
  },
  {
    latitude: 51.156390774277057,
    longitude: 3.188156627000187,
    name: "Amori",
    address: " Autobaan 7/0003, 8210 Zedelgem",
    website: "https://www.amori.be/nl/",
    phone: "+32474251993"
  },
  {
    latitude: 50.827604441420497,
    longitude: 3.269734882712871,
    name: "de Inkijk",
    address: "Overbekeplein 30/32, 8500 Kortrijk",
    website: "http://www.deinkijk.be/",
    phone: ""
  },
  {
    latitude: 51.016331365897933,
    longitude: 4.67798225387239,
    name: "Bo-T\u00e9 beauty and nails",
    address: "Schrieksebaan 230, 3140 Keerbergen",
    website: "https://bo-te.eu/",
    phone: "0496 74 71 10"
  },
  {
    latitude: 50.835221551350124,
    longitude: 4.022747753865914,
    name: "O'lys Blanc",
    address: "Graanmarkt 4, 9400 Ninove",
    website: "http://www.olysblanc.be/",
    phone: "0468 16 20 51"
  },
  {
    latitude: 51.296450275449246,
    longitude: 4.694715869285995,
    name: "Turtlee Green",
    address: "Zoerselbaan 1A, 2390 Malle",
    website: "https://www.turtleegreen.com/",
    phone: "+32479335386"
  },
  {
    latitude: 50.411719045107596,
    longitude: 4.396642840086429,
    name: "Les Essentiels de Diana",
    address: "De la, Rue de la Providence 12, 6030 Charleroi",
    website: "https://www.lesessentielsdediana.com/",
    phone: "0484 09 92 10"
  },
  {
    latitude: 45.662103239354913,
    longitude: 9.672808297869111,
    name: "Avventureeco",
    address: "Piazza F.lli Piacentini, 24052 Azzano San Paolo BG, Itali\u00eb",
    website: "https://www.avventureeco.it/",
    phone: ""
  },
  {
    latitude: 51.051100701856718,
    longitude: 3.722416996201771,
    name: "Ayuno",
    address: "Korte Meer 22, 9000 Gent",
    website: "http://www.ayuno.be/",
    phone: "09 223 12 41"
  },
  {
    latitude: 50.98222084015984,
    longitude: 3.528690597941494,
    name: "Zuskus",
    address: "Tolpoortstraat 22, 9800 Deinze",
    website: "http://www.zuskus.be/",
    phone: "+32 (0)9.398.06.90"
  },
  {
    latitude: 50.936321881719422,
    longitude: 4.040551713270388,
    name: "Philmonius",
    address: "Louis D'Haeseleerstraat 8, 9300 Aalst",
    website: "http://www.philimonius.be/",
    phone: "+32 (0)488 20 13 58"
  },
  {
    latitude: 50.531387416165479,
    longitude: 5.216867813320755,
    name: "Biomanie",
    address: "Rue Joseph Wauters 7, 4520 Wanze",
    website: "http://www.biomanie.be/",
    phone: "085 21 68 93"
  },
  {
    latitude: 51.096982210261466,
    longitude: 3.608517655669699,
    name: "Kruiden & Co",
    address: "Molendreef 19, 9920 Lievegem",
    website: "https://www.kruidenenco.be/",
    phone: "09 372 97 85"
  },
  {
    latitude: 50.32543676850473,
    longitude: 5.067687011463387,
    name: "Ferme de Stee",
    address: "Rue de St\u00e9e 61, 5590 Ciney",
    website: "https://fermedestee.be/",
    phone: "+32 498 43 95 44"
  },
  {
    latitude: 50.342321693880614,
    longitude: 5.158428226806897,
    name: "Au Petit March\u00e9 a Moi",
    address: "Chau. de Li\u00e8ge 59 A, 5360 Hamois",
    website: "",
    phone: ""
  },
  {
    latitude: 50.604025066337229,
    longitude: 5.515053642159108,
    name: "Boutique Sant\u00e9",
    address: "Rue Morchamps 40, 4100 Seraing",
    website: "http://boutiquesante.be/",
    phone: "04/338.28.33"
  },
  {
    latitude: 50.981395871294204,
    longitude: 4.458423969158332,
    name: "De Goudsbloem Zemst",
    address: "Armstraat 26, 1980 Zemst",
    website: "http://www.degoudsbloem-zemst.be/",
    phone: "015 62 07 67"
  },
  {
    latitude: 50.332770192486187,
    longitude: 4.615634753792222,
    name: "Plus Bio La Vie",
    address: "Rue Saint-Roch 35, 5640 Mettet",
    website: "http://www.plusbiolavie.be/",
    phone: "0498 41 04 18"
  },
  {
    latitude: 50.873013197475146,
    longitude: 4.386528640318695,
    name: "Le Thym Frais",
    address: "Helmetsesteenweg 184, 1030 Schaarbeek",
    website: "",
    phone: "02 215 01 10"
  },
  {
    latitude: 50.809658047724952,
    longitude: 4.314845613330767,
    name: "La Vivri\u00e8re",
    address: "Stationstraat 2, 1190 Vorst",
    website: "https://www.la-vivriere.be/",
    phone: "0487 42 36 62"
  },
  {
    latitude: 50.660675812767067,
    longitude: 4.814379755653977,
    name: "So vrac, So good!",
    address: "Rue du Maieur S\u00e9verin 1, 1360 Perwez",
    website: "http://www.sovracsogood.be/",
    phone: "0484 48 95 20"
  },
  {
    latitude: 50.809825942523375,
    longitude: 4.931093726823593,
    name: "Di\u00ebtica",
    address: "Leuvensestraat 120, 3300 Tienen",
    website: "https://www.hours.be/dietica/tienen/1",
    phone: "016 81 20 90"
  },
  {
    latitude: 50.745428867831528,
    longitude: 3.59790799798559,
    name: "Bio Boutique",
    address: "Fostierlaan 13, 9600 Ronse",
    website: "http://www.bio-boutique.be/",
    phone: "0494 17 99 18"
  },
  {
    latitude: 51.29208811663878,
    longitude: 4.447168990062529,
    name: "De Groene Wijzer",
    address: "Molenweg 18, 2930 Brasschaat",
    website: "http://www.degroenewijzer.be/",
    phone: "03 664 73 85"
  },
  {
    latitude: 50.993833551873614,
    longitude: 3.745876926830229,
    name: "Mepharma",
    address: "Hundelgemsesteenweg 652, 9820 Merelbeke",
    website: "",
    phone: ""
  },
  {
    latitude: 51.301482109284414,
    longitude: 4.568660813348498,
    name: "BioAse natuurvoeding",
    address: "Vaartlaan 11, 2960 Brecht",
    website: "http://www.biosintjob.be/",
    phone: "03 636 45 14"
  },
  {
    latitude: 49.841941821621489,
    longitude: 5.433245169117659,
    name: "Sant\u00e9 et Saveur",
    address: "6840 Neufch\u00e2teau",
    website: "http://www.santeetsaveur.be/",
    phone: "061 28 80 51"
  },
  {
    latitude: 49.699610784752835,
    longitude: 5.311407942126932,
    name: "Dame Nature",
    address: "Rue de l'Eglise 11, 6820 Florenville",
    website: "",
    phone: "061 31 49 39"
  },
  {
    latitude: 50.629106553676586,
    longitude: 4.704407669145679,
    name: "L'Archenterre",
    address: "Chem. de la Scierie 126, 1457 Walhain",
    website: "http://www.larchenterre.be/lesite/",
    phone: ""
  },
  {
    latitude: 50.44774057785817,
    longitude: 4.484459482632078,
    name: "Back to Vrac",
    address: "Pl. Fran\u00e7ois Goffe 2, 6043 Charleroi",
    website: "http://www.facebook.com/backtovrac",
    phone: "0479 29 52 62"
  },
  {
    latitude: 51.134615084893412,
    longitude: 4.445834008934361,
    name: "De Ekowinkel Kontich",
    address: "Sint-Jansplein 1/A, 2550 Kontich",
    website: "http://www.de-eko-winkel.be/",
    phone: "03 458 38 00"
  },
  {
    latitude: 50.88596594876492,
    longitude: 4.718932184497802,
    name: "Moedertje Natuur",
    address: "Baron August de Becker Remyplein 35, 3010 Leuven",
    website: "https://moedertje-natuur.be/",
    phone: "016 25 09 59"
  },
  {
    latitude: 51.048675389134864,
    longitude: 5.221632424982187,
    name: "Herba Natuurwinkel",
    address: "Onze-Lieve-Vrouwstraat 15, 3580 Beringen",
    website: "http://www.herbanatuurwinkel.be/",
    phone: "011 32 59 16"
  },
  {
    latitude: 50.94927496111201,
    longitude: 4.244916042171504,
    name: "Ekowinkel Merchtem",
    address: "Brusselsesteenweg 155, 1785 Merchtem",
    website: "https://www.ekowinkel.eu/",
    phone: "052 37 45 34"
  },
  {
    latitude: 51.15347477001383,
    longitude: 3.237798684507413,
    name: "De Goudsbloem ",
    address: "Schooldreef 33, 8020 Oostkamp",
    website: "",
    phone: "050 84 07 17"
  },
  {
    latitude: 51.08545858393618,
    longitude: 4.604803371012139,
    name: "Bioboer Busschots",
    address: "Mechelbaan 133, 2500 Lier",
    website: "https://biomijnnatuur.be/biopunten/bioboer-winkel-busschots",
    phone: "03 464 26 47"
  },
  {
    latitude: 50.945464714302325,
    longitude: 3.12338278449992,
    name: "Kruidenmozaiek",
    address: "Noordstraat 5, 8800 Roeselare",
    website: "http://www.dekruidenmozaiek.be/",
    phone: "051 20 95 87"
  },
  {
    latitude: 51.206240192163349,
    longitude: 4.041461019042919,
    name: "De Zonnebloem",
    address: "Stadionstraat 3, 9190 Stekene",
    website: "http://www.dezonnebloem.net/",
    phone: "03\u202f779\u202f96\u202f29"
  },
  {
    latitude: 51.082809697371239,
    longitude: 4.723428971164539,
    name: "Oosterlinck Home",
    address: "Molenstraat 145, 2220 Heist-op-den-Berg",
    website: "https://oosterlinck.shop/",
    phone: "015 24 11 68"
  },
  {
    latitude: 51.231694587485038,
    longitude: 2.91508644052817,
    name: "Home by Lily",
    address: "Hertstraat 5, 8400 Oostende",
    website: "http://homebylily.be/",
    phone: "059 43 38 31"
  },
  {
    latitude: 50.88619117976522,
    longitude: 3.692433311679158,
    name: "Zonnehoed",
    address: "Neerstraat 39, 9636 Zwalm",
    website: "https://www.zonnehoed.be/",
    phone: "0456 36 67 58"
  },
  {
    latitude: 51.200483614418538,
    longitude: 4.463224040526996,
    name: "L\u00f8v Elly",
    address: "Menegemlei 17, 2100 Antwerpen",
    website: "http://www.lovelly.be/",
    phone: "0476 95 24 66"
  },
  {
    latitude: 47.388801379374598,
    longitude: 0.691547042236333,
    name: "Kenze Naturel",
    address: "24 Rue Michelet, 37000 Tours, Frankrijk",
    website: "https://kenze-naturel.com/",
    phone: "+33 9 84 45 42 26"
  },
  {
    latitude: 40.634560052488901,
    longitude: 22.939950384334693,
    name: "Ecognito",
    address: "Tsimiski 16, Thessaloniki 546 23, Griekenland",
    website: "https://www.ecognito.gr/",
    phone: "6989762925"
  },
  {
    latitude: 48.74529802116222,
    longitude: 9.213077869270673,
    name: "Tante M - unverpackt",
    address: "Eduard-Steinle-Stra\u00dfe 6, 70619 Stuttgart, Duitsland",
    website: "/http://tantem-unverpackt.de/",
    phone: "+49 711 45978007"
  },
  {
    latitude: 48.859025607912848,
    longitude: 2.374589457627957,
    name: " Aujourd'hui demain",
    address: "42 Rue du Chemin Vert, 75011 Paris, Frankrijk",
    website: "http://www.aujourdhui-demain.com/",
    phone: "+33 9 81 65 20 01"
  },
  {
    latitude: 50.913978116724415,
    longitude: 2.920375371120421,
    name: "Rooselien",
    address: "Markt 21, 8920 Langemark-Poelkapelle",
    website: "http://www.rooselien.be/",
    phone: "0485 57 38 99"
  },
  {
    latitude: 46.949508106518088,
    longitude: 7.442378269205497,
    name: "Fizzen",
    address: "Ryfflig\u00e4sschen 13, 3011 Bern, Zwitserland",
    website: "https://www.fizzen.ch/",
    phone: "+41 31 311 11 16"
  },
  {
    latitude: 51.249664351376936,
    longitude: 4.496704511693031,
    name: "Make-up Brows & more ",
    address: "Jozef Hendrickxstraat 12, 2900 Schoten",
    website: "http://www.makeupwebshop.be/",
    phone: "0472 38 26 68"
  },
  {
    latitude: 51.316747210460484,
    longitude: 4.847590642382345,
    name: "Lettuce Bee Green",
    address: "Brugstraat 23, 2340 Beerse",
    website: "https://lettucebeegreen.com/",
    phone: "0493 16 68 32"
  },
  {
    latitude: 50.783895228522198,
    longitude: 3.036524969346969,
    name: "Viktor's vitrine",
    address: "Kruisekestraat 92A, 8940 Wervik",
    website: "http://www.vondels.be/",
    phone: "056 49 68 30"
  },
  {
    latitude: 50.99439468627854,
    longitude: 4.837993084698334,
    name: "Carpe Diem",
    address: "Herseltsesteenweg 49, 3200 Aarschot",
    website: "http://www.carpediemaarschot.be/",
    phone: "016 55 10 05"
  },
  {
    latitude: 51.181678360735965,
    longitude: 4.347697171213037,
    name: "EVL Praktijk",
    address: "Fodderiestraat 20, 2660 Antwerpen",
    website: "http://evl-praktijk.be/",
    phone: "0475 48 64 96"
  },
  {
    latitude: 51.215999789751422,
    longitude: 4.399299613542656,
    name: "Sincerely Valentine",
    address: "Sint-Antoniusstraat 1, 2000 Antwerpen",
    website: "http://www.sincerelyvalentine.com/",
    phone: ""
  },
  {
    latitude: 51.144667149914632,
    longitude: 3.954404057719172,
    name: "Body Treats",
    address: "Bautschoot 21, 9160 Lokeren",
    website: "http://www.bodytreats.be/",
    phone: "0496 49 42 48"
  },
  {
    latitude: 50.87831942231729,
    longitude: 4.164024857671393,
    name: "Cups & Co",
    address: "Assesteenweg 100, 1740 Ternat",
    website: "http://www.cupsandco.be/",
    phone: "02 582 18 49"
  },
  {
    latitude: 51.317009620804903,
    longitude: 3.294462269364407,
    name: "Studio M",
    address: "Het Walletje 106/unit 3, 8300 Knokke-Heist",
    website: "https://studio-m-knokke.be",
    phone: "0474 66 40 84"
  },
  {
    latitude: 51.138323111306036,
    longitude: 5.793889297881096,
    name: "Sogni Natura - Health & Beauty bar",
    address: "Drietak 50, 3640 Kinrooi",
    website: "https://sogninatura.be/",
    phone: "0472 67 71 04"
  },
  {
    latitude: 51.226093436359797,
    longitude: 2.964569797884497,
    name: "ANDRS Concept Store Bredene",
    address: "Fritz Vinckelaan 80C, 8450 Bredene",
    website: "https://www.andrs.be/",
    phone: "+32 486 02 74 97"
  },
  {
    latitude: 50.936041940727264,
    longitude: 4.365318126709005,
    name: "Ren\u00e9e shop",
    address: "Wolvertemsesteenweg 100, 1850 Grimbergen",
    website: "https://www.reneeshop.be/service/",
    phone: "02 304 72 07"
  },
  {
    latitude: 50.947356198618508,
    longitude: 3.143211769038077,
    name: "Boost moodshop",
    address: "Mandellaan 307, 8800 Roeselare",
    website: "https://www.boostmoodshop.be/",
    phone: "051 80 48 05"
  },
  {
    latitude: 51.324293698886244,
    longitude: 4.86230904029088,
    name: "Homemade HappINESs",
    address: "Leemstraat 48 B, 2340 Beerse",
    website: "https://www.homemade-happiness.be/",
    phone: "0479 44 36 90"
  },
  {
    latitude: 51.209642091603364,
    longitude: 4.662773269121492,
    name: "Studio Sanne",
    address: "Bruggestraat 46,2240 Zandhoven",
    website: "https://www.studiosanne.be/",
    phone: "03 314 70 95"
  },
  {
    latitude: 51.145512681980222,
    longitude: 3.95443423785646,
    name: "Body Treats Schoonheidszorgen",
    address: "Bautschoot 21, 9160 Lokeren",
    website: "http://www.bodytreats.be/",
    phone: "0496 49 42 48"
  },
  {
    latitude: 51.1206178120581,
    longitude: 3.001226267948944,
    name: "Fienesse",
    address: "Stationsstraat 393, 8480 Ichtegem",
    website: "https://www.fienesse.be/",
    phone: "0495 40 31 72"
  },
  {
    latitude: 50.85049313560377,
    longitude: 2.884578267789737,
    name: "Fygge",
    address: "Boomgaardstraat 6, 8900 Ieper",
    website: "http://www.fygge.be/",
    phone: "0491 91 44 17"
  },
  {
    latitude: 50.92946137146842,
    longitude: 5.33539813715454,
    name: "Huis de Cat",
    address: "Havermarkt 27, 3500 Hasselt",
    website: "http://www.huisdecat.be/",
    phone: "011 22 26 43"
  },
  {
    latitude: 50.924417103414306,
    longitude: 5.316639667833089,
    name: "HuisNummer1",
    address: "Fazantenstraat 1, 3500 Hasselt",
    website: "http://www.huisnummer1.be/",
    phone: ""
  },
  {
    latitude: 51.234867599901627,
    longitude: 2.932736053814231,
    name: "Kabine Oostende",
    address: "Fortstraat 16, 8400 Oostende",
    website: "http://www.kabine.be/",
    phone: "059 42 64 13"
  },
  {
    latitude: 51.22376326549351,
    longitude: 4.404335891373124,
    name: "Kiez",
    address: "Minderbroedersrui 55, 2000 Antwerpen",
    website: "http://www.kiez.be/",
    phone: "0495 90 52 90"
  },
  {
    latitude: 51.034833336338934,
    longitude: 3.717568352557587,
    name: "Exter 8",
    address: "Exterkenstraat 8, 9310 Aalst",
    website: "",
    phone: "0495 37 65 64"
  },
  {
    latitude: 50.826525632983298,
    longitude: 3.269573921753216,
    name: "Melanie Six",
    address: "Sionstraat 4, 8500 Kortrijk",
    website: "http://www.melaniesix.com/",
    phone: "0484 41 41 91"
  },
  {
    latitude: 51.170758482935213,
    longitude: 4.185220921955962,
    name: "Mor\u0117m\u00ed",
    address: "Lange Rekstraat 14, 9100 Sint-Niklaas",
    website: "http://www.moremi.be/",
    phone: "0471.43.96.23"
  },
  {
    latitude: 51.071088640806664,
    longitude: 5.124932521897254,
    name: "Pastelle Beautybar",
    address: "Genenbosstraat 20, 3980 Tessenderlo",
    website: "https://www.pastellebeautybar.be/",
    phone: "013 30 42 66"
  },
  {
    latitude: 51.170714290993651,
    longitude: 4.452499583319281,
    name: "Rand Store Antwerpen",
    address: "Statielei 65, 2640 Mortsel",
    website: "http://www.rand-store.be/",
    phone: "03 334 63 22"
  },
  {
    latitude: 51.230516500035236,
    longitude: 2.915371737332042,
    name: "Maison Saints&Bullies",
    address: "Wittenonnenstraat 69, 8400 Oostende",
    website: "https://www.maisonsb.be/",
    phone: ""
  },
  {
    latitude: 51.231586697713148,
    longitude: 2.915086540427055,
    name: "Lily Oostende",
    address: "Hertstraat 5, 8400 Oostende",
    website: "https://shoplily.be/",
    phone: "059 43 38 31"
  },
  {
    latitude: 51.467223138246744,
    longitude: 4.469030918206674,
    name: "SOFlien",
    address: "Nieuwstraat 42, 2910 Essen",
    website: "http://soflien.com/",
    phone: "0494 93 15 67"
  },
  {
    latitude: 51.208186101125229,
    longitude: 3.448064338572092,
    name: "Waanzinnig Gedroomd",
    address: "Boudewijn Lippensstraat 13, 9990 Maldegem",
    website: "http://www.waanzinniggedroomd.be/",
    phone: "050 85 87 88"
  },
  {
    latitude: 51.208053374727172,
    longitude: 3.448258416332342,
    name: "Bombs",
    address: "Broekstraat 7, 9310 Aalst",
    website: "http://www.bombs.be/",
    phone: ""
  },
  {
    latitude: 51.119326124583274,
    longitude: 2.633789011586637,
    name: "Kabine",
    address: "Maurice Blieckstraat 11, 8670 Koksijde",
    website: "http://www.kabine.be/",
    phone: "058 59 85 95"
  },
  {
    latitude: 51.173645859313112,
    longitude: 3.923031198097521,
    name: "Familie Oliefant",
    address: "Terwestvaart 11, 9180 Moerbeke",
    website: "https://www.familieoliefant.be/",
    phone: "0495 69 33 91"
  },
  {
    latitude: 51.163444079583009,
    longitude: 4.995617569260872,
    name: "Roos met Witte Stippen",
    address: "Nieuwstraat 128, 2440 Geel",
    website: "https://www.roosmetwittestippen.com/",
    phone: "0032(0)495617261"
  },
  {
    latitude: 51.026859535046015,
    longitude: 4.100871355764752,
    name: "Mon Ciel",
    address: "Brusselsestraat 71, 9200 Dendermonde",
    website: "http://www.monciel.be/",
    phone: "052 21 13 48"
  },
  {
    latitude: 50.771833194499308,
    longitude: 3.877661769246563,
    name: "Cosiwool",
    address: "Grotestraat 45A, 9500 Geraardsbergen",
    website: "http://www.cosiwool.be/",
    phone: ""
  },
  {
    latitude: 50.880016244814421,
    longitude: 4.699914177236202,
    name: "Harvest Club",
    address: "Mathieu de Layensplein 7, 3000 Leuven",
    website: "https://harvestclub.be/",
    phone: "+32 16 58 30 61"
  },
  {
    latitude: 51.137240773376377,
    longitude: 4.687524304824296,
    name: "Bloom - Holistic beauty & balance",
    address: "Bremlaan 19, Bornem",
    website: "http://www.praktijk-bloom.be/",
    phone: "0496/31.53.36"
  },
  {
    latitude: 53.008640835395084,
    longitude: 6.762725011656874,
    name: "JuF\u00e9",
    address: "Naweg 33, 9461 BK GIETEN, Nederland",
    website: "https://www.soapbarstore.nl/",
    phone: "06 30046475"
  },
  {
    latitude: 51.212685842229156,
    longitude: 4.323455040426348,
    name: "Shop V-Roo",
    address: "Heidestraat 57, 2070 Zwijndrecht",
    website: "http://www.shopv-roo.be/",
    phone: "0491 56 76 74"
  },
  {
    latitude: 51.310578473026986,
    longitude: 4.408435498102556,
    name: "NaturalBeautyCare By Wendy",
    address: "Palmenlaan 47, 2940 Stabroek",
    website: "http://www.naturalbeautycarebywendy.be/",
    phone: "0486 209 142"
  },
  {
    latitude: 51.206152966923455,
    longitude: 3.21825362693504,
    name: "G\u00e4ststore & Bar",
    address: "NOORDZANDSTRAAT 93, 8000 BRUGGE",
    website: "https://www.gast.store/shop",
    phone: ""
  },
  {
    latitude: 51.171259444649799,
    longitude: 3.046146771164308,
    name: "Hanghaar Ciseaux",
    address: "Brugsesteenweg 227a, 8460 Roksem",
    website: "https://www.kapsalon-ciseaux.be/",
    phone: "05081 25 77"
  },
  {
    latitude: 52.051944065729217,
    longitude: 6.311745069293655,
    name: "LEF-store",
    address: "Bleekstraat 1, 7255 XZ Hengelo Gelderland",
    website: "https://lef-store.nl/",
    phone: "+31 6 13815647"
  },
  {
    latitude: 51.187129302636741,
    longitude: 3.566436169261723,
    name: "Mooi!",
    address: "Boelare 64, 9900 Eeklo",
    website: "https://www.mooi-eeklo.be/",
    phone: "09 377 07 00"
  },
  {
    latitude: 50.86227760535936,
    longitude: 4.244536038566284,
    name: "Roccoville Concept Store",
    address: "Assesteenweg 228a, 1750 Eizeringen (Lennik)",
    website: "https://roccoville.be/",
    phone: "0474 47 94 03"
  },
  {
    latitude: 51.216808223697313,
    longitude: 4.401251911634175,
    name: "Apotheek City-Pharma",
    address: "Kammenstraat 61, 2000 Antwerpen",
    website: "https://www.city-pharma.be/",
    phone: "03/232.77.55"
  },
  {
    latitude: 51.220449611924181,
    longitude: 4.402543025527473,
    name: "Akotee",
    address: "Melkmarkt 30, 2000 Antwerpen",
    website: "https://www.akotee.be/",
    phone: "+32 (0)3 213.23.13"
  },
  {
    latitude: 50.814551635878502,
    longitude: 5.185523283519833,
    name: "Clockempoortje",
    address: "Clockemstraat 14,3800 Sint-Truiden",
    website: "https://www.clockempoortje.be/",
    phone: "011/681823"
  },
  {
    latitude: 50.978920000000002,
    longitude: 4.85022,
    name: "Ik Smeer Belgisch",
    address: "Schoonhovenbos 4, 3200 Aarschot",
    website: "https://theworldofbam.com/",
    phone: "0498409719"
  },
  {
    latitude: 51.346789999999999,
    longitude: 3.28786,
    name: "Juttu Knokke-Heist",
    address: "Lippenslaan 175,8300 Knokke-Heist",
    website: "https://www.juttu.be/nl.html",
    phone: "0478/731677"
  },
  {
    latitude: 43.021479999999997,
    longitude: 0.17752,
    name: "Juttu Hasselt",
    address: "Quartier Bleu Gelatineboulevard 4/0.05,3500 Hasselt",
    website: "https://www.juttu.be/nl.html",
    phone: "011/28.49.70"
  },
  {
    latitude: 51.207039999999999,
    longitude: 3.21941,
    name: "Juttu Brugge",
    address: "Noordzandstraat 54, 8000 Brugge",
    website: "https://www.juttu.be/nl.html",
    phone: "050/33.10.06"
  },
  {
    latitude: 51.218649999999997,
    longitude: 4.40637,
    name: "Juttu Antwerpen",
    address: "Meir 19, 2000 Meir",
    website: "https://www.juttu.be/nl.html",
    phone: "03/231.10.44"
  },
  {
    latitude: 50.945590000000003,
    longitude: 3.1254,
    name: "Juttu Roeselare",
    address: "Ooststraat 20/22, 8800 Roeselare",
    website: "https://www.juttu.be/nl.html",
    phone: "051/22.27.66"
  },
  {
    latitude: 51.051130000000001,
    longitude: 3.72503,
    name: "Juttu Gent",
    address: "Kouterdreef 2, 9000  Gent",
    website: "https://www.juttu.be/nl.html",
    phone: "093752427"
  },
  {
    latitude: 50.767800000000001,
    longitude: 3.62121,
    name: "Schoon schuim",
    address: "Sint-Martensplein 3A, 9600 Ronse",
    website: "https://www.schoonschuim.be/",
    phone: "+ 32 (0)486071274 "
  },
  {
    latitude: 50.967889999999997,
    longitude: 4.7604,
    name: "Nails & Beauty by Amandine",
    address: "Elzendreef 31, 3110 Rotselaar",
    website: "https://nbamandine.posworld.be/#/listws",
    phone: "+ 32 (0)498 63 77 42"
  },
  {
    latitude: 51.150399999999998,
    longitude: 4.09242,
    name: "Oremano Kruiderie",
    address: "Gavermolenstraat 41, 9111 Belsele",
    website: "https://www.facebook.com/OremanoKruiderie/",
    phone: "+ 32 (0)485629723"
  },
  {
    latitude: 50.971679999999999,
    longitude: 4.17861,
    name: "Yemaya Massage",
    address: "Klaarstraat, 34, 1745 Opwijk",
    website: "https://www.yemayamassage.be/",
    phone: "+ 32 (0)474576162"
  },
  {
    latitude: 51.13973,
    longitude: 4.02608,
    name: "Simply Pretty",
    address: "Hulstbaan 256, 9112 Sinaai",
    website: "https://www.simplypretty.be/",
    phone: "+ 32 (0)496 75 76 77"
  },
  {
    latitude: 51.205188999999997,
    longitude: 3.22073,
    name: "Sillie Boetiek",
    address: "Sint-Salvatorskerkhof 18, 8000 Brugge",
    website: "https://sillie.be/",
    phone: "+ 32 (0)475 80 53 42"
  },
  {
    latitude: 50.889828654961065,
    longitude: 3.784229315498236,
    name: "Apotheek De Cooman",
    address: "Provinciebaan 244, 9620 Zottegem-Velzeke",
    website: "https://www.apotheekdecooman.be/",
    phone: "09 360 25 83"
  },
  {
    latitude: 51.098733961282328,
    longitude: 4.503726869494382,
    name: "Ergosun Duffel",
    address: "Kiliaanstraat 30, 2570 Duffel",
    website: "https://ergosun.be/",
    phone: "015 31 00 30"
  },
  {
    latitude: 51.272620815695227,
    longitude: 4.460268293978579,
    name: "Ergosun Ekeren",
    address: "Kapelsesteenweg 3, 2180 Antwerpen",
    website: "https://ergosun.be/",
    phone: "03 666 32 20"
  },
  {
    latitude: 51.215299454592696,
    longitude: 4.254462867670787,
    name: "Ergosun Beveren",
    address: "Oude Zandstraat 17, 9120 Beveren",
    website: "https://ergosun.be/",
    phone: "03 775 12 44"
  },
  {
    latitude: 51.089764606503955,
    longitude: 4.363599214316804,
    name: "Ergosun Boom",
    address: "Groene Hofstraat 45, 2850 Boom",
    website: "https://ergosun.be/",
    phone: "03 369 50 22"
  },
  {
    latitude: 51.201717734779621,
    longitude: 4.490875744137909,
    name: "Ergosun Borsbeek",
    address: "Herentalsebaan 187, 2150 Borsbeek",
    website: "https://ergosun.be/",
    phone: "03 482 14 44"
  },
  {
    latitude: 51.064424758218429,
    longitude: 4.360326812817097,
    name: "Ergosun Willebroek",
    address: "Louis de Naeyerplein 30, 2830 Willebroek",
    website: "https://ergosun.be/",
    phone: "03 866 46 23"
  },
  {
    latitude: 50.979263292029877,
    longitude: 5.044045507509657,
    name: "SimplyMe Diest",
    address: "Leuvensesteenweg 86/A, 3290 Diest",
    website: "https://simplyme.be/",
    phone: "013 69 00 67"
  },
  {
    latitude: 51.317226698230314,
    longitude: 4.928311874057629,
    name: "SimplyMe Turnhout",
    address: "Steenweg op Gierle 195, 2300 Turnhout",
    website: "https://simplyme.be/",
    phone: "03 677 29 67"
  },
  {
    latitude: 51.174403131278723,
    longitude: 4.393450637057652,
    name: "SimplyMe Wilrijk",
    address: "Kleinesteenweg 3, 2610 Antwerpen",
    website: "https://simplyme.be/",
    phone: "03 827 14 44"
  },
  {
    latitude: 51.203170158540864,
    longitude: 4.451118712348722,
    name: "SimplyMe Borgerhout",
    address: "Gitschotellei 297, 2140 Antwerpen",
    website: "https://simplyme.be/",
    phone: "03 337 46 67"
  },
  {
    latitude: 51.15701332852656,
    longitude: 4.568375625699455,
    name: "SimplyMe Lier",
    address: "Grote Markt 54, 2500 Lier",
    website: "https://simplyme.be/",
    phone: "03 480 33 37"
  },
  {
    latitude: 51.201170412190081,
    longitude: 3.181713121325347,
    name: "Aptheek De Pauw Sint-Andries",
    address: "Gistelse Steenweg 504, 8200 Brugge",
    website: "https://apotheekdepauw.be/apotheek-de-pauw-sint-andries/",
    phone: "050 38 92 60"
  },
  {
    latitude: 51.188664572066557,
    longitude: 3.14276867596637,
    name: "Apotheek De Pauw Varsenare",
    address: "Oude Dorpsweg 85, 8490 Jabbeke",
    website: "https://apotheekdepauw.be/apotheek-de-pauw-varsenare/",
    phone: "050 39 43 88"
  },
  {
    latitude: 50.720685796109365,
    longitude: 5.128579483725328,
    name: "Apotheek Collin",
    address: "Brugstraat 7, 3890 Gingelom",
    website: "https://apotheekcollin.be",
    phone: "011 88 18 85"
  },
  {
    latitude: 50.91998290817321,
    longitude: 3.335033099077683,
    name: "Apotheek CE Farma",
    address: "Markt 3, 8780 Oostrozebeke",
    website: "https://www.cefarma.be",
    phone: "056 66 63 14"
  },
  {
    latitude: 51.149141889452153,
    longitude: 4.455244814103917,
    name: "Het Speelaterlier",
    address: "Sint Goriksplein 8, 2650 Edegem",
    website: "https://hetspeelatelier.be",
    phone: "0497 84 58 98"
  }
];